<template>
  <div class="container" v-show="loaded">
    <div class="res_head">
      <div class="res_head__fixed">
        <div class="res_head__fixed__box">
          <div class="res_header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="res_header__fixed__center">
            <div class="enname">{{stadium_current.en_name}}</div>
            <div class="chname">{{stadium_current.name}}</div>
          </div>
          <div class="res_header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="vertical">
      <van-swipe class="vertical_item" vertical ref="swiper" :loop="false" :show-indicators="false" :lazy-render="true" :stop-propagation="false" :initial-swipe="initialswipe" @change="verticalSwiper">
        <van-swipe-item v-for="(stadiumItem,stadiumIndex) in stadium_list" :key="stadiumIndex" class="vertical_item_bock">

          <van-swipe :loop="true" :show-indicators="false" class="level">
            <van-swipe-item v-for="(levelItem,levelIndex) in stadiumItem.env_imgs" :key="levelIndex"  class="level_item">
              <!-- v-lazy:background-image='levelItem' -->
              <div class="bglevel_item"  v-lazy:background-image='levelItem'></div>
              <!-- 主蒙版 -->
              <div @click.stop.prevent="closeAllTemplate()" class="level_item_mask"></div>
              <!-- 做蒙版 -->
              <div @click.stop.prevent="closeAllTemplate()" class="level_item_leftmask"></div>
              <!-- tag -->
              <div @click.stop.prevent="closeAllTemplate()" class="level_item_num">{{levelIndex+1}}/<label>{{stadiumItem.env_imgs.length}}</label></div>
              <!-- arrow -->
              <img @click.stop.prevent="closeAllTemplate()" class="level_item_carousel" src="../../assets/images/base/arrows_carousel_icon.png" />
              <!-- address -->
              <div @click.stop.prevent="closeAllTemplate()" class="reserves_fullpage_first_point" v-if="levelIndex==0">
                <div>
                  <div class="reserves_fullpage_first_point_name">{{stadiumItem.name}}</div>
                  <div class="reserves_fullpage_first_point_enname">{{stadiumItem.en_name}}</div>
                  <div class="reserves_fullpage_first_point_distance" v-if="stadiumItem.distance != -1">
                    <div class="reserves_fullpage_first_point_distance_icon"></div>
                    距离{{stadiumItem.distance}}
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <!-- tag -->
          <div @click.stop.prevent="closeAllTemplate()" class="level_item_tag">
            <label v-for="(tagItem,tagIndex) in stadiumItem.tag_arr">{{tagItem}}</label>
          </div>
        </van-swipe-item>
      </van-swipe>
      <!-- 左侧预约、视频、介绍功能按钮 -->
      <stadiumDetailFunctionArea @toCreateOrder="toCreateOrder" @toOpenVideo="toOpenVideo" @toOpenDesc="toOpenDesc" :stadium_current="stadium_current"></stadiumDetailFunctionArea>
      <!-- <div class="vertical_function">
        <div v-show="stadium_current.is_black_vip==1" class="vertical_function_item">
          <wx-open-launch-weapp id="launch-btn" username="gh_9f895bb61a7d" path="pages/fb_index/fb_index.html">
            <script type="text/wxtag-template">
              <style>
                .btn {width: 60px;background: none;border: none;outline: none;}
                .btniiiii{width: 45px;}
              </style>
              <button class="btn">
                <img class="btniiiii" src="http://img.unionfit.cn/blackvip.png" />
              </button>
            </script>
          </wx-open-launch-weapp>
        </div>
        <div v-show="stadium_current.is_black_vip!=1" class="vertical_function_item">
          <img src="../../assets/images/base/order.png" />
          <div>预约</div>
          <button @click="toCreateOrder()" v-preventReClick></button>
        </div>
        <div v-if="stadium_current.env_video==''||stadium_current.env_video==null||stadium_current.env_video==undefined"></div>
        <div v-else class="vertical_function_item">
          <img src="../../assets/images/base/video.png" />
          <div>视频</div>
          <button @click="toOpenVideo()" v-preventReClick></button>
        </div>
        <div class="vertical_function_item">
          <img src="../../assets/images/base/description.png" />
          <div>介绍</div>
          <button @click="toOpenDesc()" v-preventReClick></button>
        </div>
      </div> -->
      <div  @click="switchUpArrow()" class="vertical_uoArrow">
        <img src="../../assets/images/base/next_hotel.gif" />
        <!-- <div :style="'float: left;width: 50px;height: 50px;background-image: url('+require('../../assets/images/base/next_hotel.gif')+');'"></div> -->
      </div>
      <!-- 预约日期弹出层 -->
      <div :class="order_panel_status?'order_panel order_active animated fadeInUp':'order_panel animated fadeOutDown'">
        <div class="order_block">
          <div @click.stop.prevent="closeAllTemplate()" class="order_block_close"></div>
          <!-- 预约日期标题 -->
          <div class="order_block_title">
            <div v-for="(orderItem,orderIndex) in order_title_arr" @click.stop.prevent="switchOrderTitle(orderItem)" class="order_block_title_lab" :style="'width: calc(100% / '+order_title_arr.length+');'">
              <div>
                {{orderItem}}
                <img v-show="order_title==orderItem" class="order_block_title_lab_item_lable" src="../../assets/images/FLVersion/fl_typetitle.png" />
                <!-- <label :class="[{'order_block_title_lab_item_lable':order_title==orderItem}]"></label> -->
              </div>
            </div>
          </div>
          <div class="clearboth"></div>
          <!-- 健身模块 -->
          <div v-show="order_title=='沸健身'">
            <div class="order_block_dateOrder">
              <div :class="[{'order_fit_son_liu':order_fit_arr.length==6},{'order_fit_son_qi':order_fit_arr.length==7},{'order_fit_son_ba':order_fit_arr.length==8},{'order_fit_son_jiu':order_fit_arr.length==9},'order_son']">
                <div v-for="(item_fit,index_fit) in order_fit_arr"  @click.stop.prevent="selectFitDate(item_fit,index_fit)" :id="'anchor'+index_fit" :class="[{'order_son_item_select':select_fit_index==index_fit},'order_son_item order_son_item_posi']">

                  <div v-show="select_fit_index != index_fit" :class="[{'order_son_item_titleempty':item_fit.free_cnt==0},'order_son_item_title']">{{item_fit.week}}</div>
                  <div v-show="select_fit_index == index_fit" :class="[{'order_son_item_titleSelect':item_fit.free_cnt>0},'order_son_item_title']">{{item_fit.week}}</div>

                  <div v-show="item_fit.free_cnt==0" :class="[{'order_son_item_itemempty':item_fit.free_cnt==0},'order_son_item_item']">{{((item_fit.date).substring(5,10)).replace(/-/g,'.')}}</div>
                  <div v-show="item_fit.free_cnt>0" :class="[{'order_son_item_itemnoempty':item_fit.free_cnt>0},{'order_son_item_itemnoemptyselecty':select_fit_index == index_fit},'order_son_item_item']">{{((item_fit.date).substring(5,10)).replace(/-/g,'.')}}</div>

                  <img v-show="item_fit.free_cnt==0" class="order_son_item_posi_icon" src="../../assets/images/base/appointfull_icon.png" />

                </div>
              </div>

            </div>
            <div class="fl_order_fit_son_tips">
              <img src="../../assets/images/FLVersion/fl_fill.png" />
              请提前2小时进行预约，17点后将不能预约当天
            </div>
            <div v-show="select_fit_date==null" class="order_son_submitNo">预约游泳健身</div>
            <div v-show="select_fit_date!=null" @click.stop.prevent="tocreateOrderO()" class="order_son_submit">预约游泳健身</div>
            <!-- select_fit_date -->
          </div>
          <!-- 瑜伽模块 -->
          <div v-show="order_title=='翡瑜伽'">

            <div class="order_yoga_date">
              <!-- :style="'transform: translateX(-'+ 22.66666667*select_yoga_transform +'vw)'" -->
              <div  :class="[{'order_yoga_sonba':order_yoga_arr.length==8},{'order_yoga_sonjiu':order_yoga_arr.length==9},{'order_yoga_sonliu':order_yoga_arr.length==6},'order_yoga_son']">
                <div v-for="(item_yoga,index_yoga) in order_yoga_arr" @click.stop.prevent="selectCourse(item_yoga,index_yoga)" :id="'anchoryoga'+index_yoga" :class="[{'order_yoga_date_item_select':index_yoga==select_yoga_index},'order_yoga_date_item ']">

                  <!-- <div v-show="item_yoga.courses.length !=0" :class="[{'order_yoga_date_item_dateselect':select_yoga_index==index_yoga},'order_yoga_date_item_date']">{{(item_yoga.date).substring(5,10)}}</div>
                  <div v-show="item_yoga.courses.length ==0" :class="[{'order_yoga_date_item_dateempty':item_yoga.courses.length ==0},'order_yoga_date_item_date']">{{(item_yoga.date).substring(5,10)}}</div>
                  <div v-show="item_yoga.courses.length>0" :class="[{'order_yoga_date_item_itemempty':item_yoga.courses.length==0},'order_yoga_date_item_item']">{{item_yoga.week}}</div>
                  <div v-show="item_yoga.courses.length==0" :class="[{'order_yoga_date_item_itemempty':item_yoga.courses.length==0},'order_yoga_date_item_item']">未排课</div> -->
                  <div v-show="item_yoga.courses.length !=0" :class="[{'order_yoga_date_item_dateselect':select_yoga_index==index_yoga},'order_yoga_date_item_date']">{{item_yoga.week}}</div>
                  <div v-show="item_yoga.courses.length ==0" :class="[{'order_yoga_date_item_dateempty':item_yoga.courses.length ==0},'order_yoga_date_item_date']">{{item_yoga.week}}</div>
                  <div v-show="item_yoga.courses.length>0" :class="[{'order_yoga_date_item_itememptys':item_yoga.courses.length==0},{'order_yoga_date_item_itemseselct':select_yoga_index==index_yoga},'order_yoga_date_item_item']">{{((item_yoga.date).substring(5,10)).replace(/-/g,'.')}}</div>
                  <div v-show="item_yoga.courses.length==0" :class="[{'order_yoga_date_item_itemempty':item_yoga.courses.length==0},'order_yoga_date_item_item']">未排课</div>

                </div>
              </div>
            </div>

            <!-- <div class="fl_yogaCourse">
              <span v-for="(yoga_course_item,yogaCourse_index) in order_yoga_arr_course" @click.stop.prevent="selectYogaCourse(yoga_course_item)" :class="[{'fl_yogaCourse_itemS':current_yoga_course==yoga_course_item},'fl_yogaCourse_item']">
                <img v-show="current_yoga_course==yoga_course_item" class="fl_yogaCourse_item_img" src="../../assets/images/FLVersion/nav_locationselect_fix.png" />
                {{yoga_course_item.sd_course_name}} {{(yoga_course_item.start_time).substring(11,16)}}-{{(yoga_course_item.end_time).substring(11,16)}}
                <img v-show="current_yoga_course==yoga_course_item" class="fl_yogaCourse_itemthr" src="../../assets/images/FLVersion/bubble.png" />
              </span>
              <div class="clearboth"></div>
            </div>
            <div class="fl_yogaCourse_detail">
              当前课程详情[未选中状态]
            </div> -->
            <!-- <div v-if="fl_coursemodle==null"></div>
            <div v-else class="fl_yogaCourse_detail">
              <div class="fl_yogaCourse_detail_title">
                {{fl_coursemodle.sd_course_name}}  {{(fl_coursemodle.start_time).substring(11,16)}}-{{(fl_coursemodle.end_time).substring(11,16)}}
                <label v-if="new Date((fl_coursemodle.end_time).replace(/-/g,'/')).getTime() > (new Date().getTime() + 10800000)" class="fl_yogaCourse_detail_title_la">
                  剩余
                  <label>{{fl_coursemodle.galleryful-fl_coursemodle.order_cnt}}</label>
                  名额
                  <div>{{fl_coursemodle.order_cnt}}/{{fl_coursemodle.galleryful}}人</div>
                </label>
                <label v-else class="fl_yogaCourse_detail_title_la">
                  已结束
                </label>
              </div>
              <div class="fl_yogaCourse_detail_diff">
                难度指数
                <van-rate v-model="fl_coursemodle.difficulty_grade" allow-half :icon="imgstar" :void-icon="imgstarno" readonly size='3vw' gutter='3' />
                &nbsp;&nbsp;{{fl_coursemodle.sd_coach_name}}
              </div>
              <div v-html="fl_coursemodle.introduce" class="fl_yogaCourse_detail_desc"></div>
            </div> -->

            <!-- 课程信息 -->
            <div v-show="order_yoga_arr_course.length>0" class="fl_yc">
              <div class="fl_yogaCourse">
                <div v-for="(oyac_item,oyac_index) in order_yoga_arr_course" @click="selectYogaCourse(oyac_item)"  :class="[{'fl_yogaCourse_itemS':oyac_item==current_yoga_course},'fl_yogaCourse_item']">
                  {{oyac_item.sd_course_name}}<br>{{(oyac_item.start_time).substring(11,16)}}-{{(oyac_item.end_time).substring(11,16)}}
                  <img v-if="oyac_item==current_yoga_course" class="fl_yogaCourse_item_arrow" src="../../assets/images/FLVersion/bubble.png" />
                </div>
              </div>
            </div>
            <div v-if="current_yoga_course==null"></div>
            <div v-else @click="selectYogaCourse(current_yoga_course)" class="fl_ycDetail">
              <div class="fl_ycDetail_title">
                <span class="fl_ycDetail_title_sur">
                  {{current_yoga_course.sd_course_name}}&nbsp;
                  {{(current_yoga_course.start_time).substring(11,16)}}-{{(current_yoga_course.end_time).substring(11,16)}}
                </span>

                <span v-show="current_yoga_course.over_order_time==1" class="fl_ycDetail_title_surplus">
                  剩余
                  <label>{{current_yoga_course.galleryful-current_yoga_course.order_cnt}}</label>
                  名额
                </span>
                <span v-show="current_yoga_course.over_order_time==0 && current_yoga_course.order_cnt>0" class="fl_ycDetail_title_surplus">
                  已结束
                </span>
                <span v-show="current_yoga_course.over_order_time==0 &&
                              current_yoga_course.order_cnt==0 &&
                              new Date().getTime() >= 0*60*60*1000 + new Date((current_yoga_course.start_time).replace(/-/g,'/')).getTime()"
                      class="fl_ycDetail_title_surplus">
                  已结束
                </span>
                <span v-show="current_yoga_course.over_order_time==0 &&
                              current_yoga_course.order_cnt==0 &&
                              new Date().getTime() < 0*60*60*1000 + new Date((current_yoga_course.start_time).replace(/-/g,'/')).getTime()"
                      class="fl_ycDetail_title_surplus">
                  已取消
                </span>
              </div>
              <div class="fl_ycDetail_stitle">
                难度指数
                <van-rate v-model="current_yoga_course.difficulty_grade" allow-half :icon="imgstar" :void-icon="imgstarno" readonly size='3vw' gutter='3' />
                &nbsp;&nbsp;{{current_yoga_course.sd_coach_name}}
                <!-- <label v-show="current_yoga_course.over_order_time==0 && current_yoga_course.order_cnt>0" class="fl_ycDetail_stitle_surplus">{{current_yoga_course.galleryful}}/{{current_yoga_course.galleryful}}人</label> -->
                <!-- <label v-show="current_yoga_course.over_order_time==0 && current_yoga_course.order_cnt==0" class="fl_ycDetail_stitle_surplus">{{current_yoga_course.order_cnt}}/{{current_yoga_course.galleryful}}人</label> -->
                <label v-show="current_yoga_course.over_order_time==1" class="fl_ycDetail_stitle_surplus">{{current_yoga_course.order_cnt}}/{{current_yoga_course.galleryful}}人</label>
              </div>
              <div v-html="current_yoga_course.introduce" class="fl_ycDetail_desc"></div>

            </div>
            <img v-show="order_yoga_arr_course.length==0" class="order_yoga_course_empty" src="../../assets/images/base/noclass_emptystate.png" />

            <div v-show="fl_curYogaCourse==null" class="order_yoga_submitno">预约瑜伽课程</div>
            <div v-show="fl_curYogaCourse!=null" @click.stop.prevent="yogaToCreateOrder()" class="order_yoga_submit">预约瑜伽课程</div>
          </div>
        </div>
      </div>
      <!-- 介绍弹出层 -->
      <div :class="desc_status?'desc desc_avtive animated fadeInUp':'desc animated fadeOutDown'">
        <div class="desc_cont">
          <div v-if="false" class="desc_cont_address">{{stadium_current_detail.address}}</div>
          <div v-if="false" class="desc_cont_serves">
            <div class="desc_title">酒店服务</div>
            <div class="desc_Service_cont">
              <div v-for="(services_item,services_index) in services_arr" @click.stop.prevent="clickServiceDesc(services_item)" class="desc_Service_cont_item">
                <img :src="servicesimg[services_item]" />
                {{services[services_item]}}
              </div>
              <div class="clearboth"></div>
            </div>
            <div v-show="services_status" v-html="services_txt" class="desc_Service_detailDesc"></div>
          </div>
          <div v-if="false" v-show="business_time_status" class="desc_cont_businesstime">
            <div class="desc_cont_businesstime_title">营业时间</div>
            <div v-html="stadium_current_detail.business_time" class="desc_cont_businesstime_cont"></div>
          </div>
          <div v-if="false" class="desc_cont_businesstime">
            <div class="desc_cont_businesstime_title">预约说明</div>
            <div v-html="stadium_current_detail.book_tip" class="desc_cont_businesstime_cont"></div>
          </div>
          <div v-if="false" class="desc_cont_businesstime desc_cont_businesstime_bott">
            <div class="desc_cont_businesstime_title">酒店描述</div>
            <div v-html="stadium_current_detail.introduce" class="desc_cont_businesstime_cont"></div>
          </div>
          <div class="fl_des_tab">
            <div class="fl_des_tab_head">
              <div @click="FLSelectDesTab('基础信息')" :class="[{'fl_des_tab_head_itemS':fl_des_tab_item=='基础信息'},'fl_des_tab_head_item']">基础信息</div>
              <div @click="FLSelectDesTab('预约规则')" :class="[{'fl_des_tab_head_itemS':fl_des_tab_item=='预约规则'},'fl_des_tab_head_item fl_des_tab_head_item2']">预约规则</div>
              <div @click="FLSelectDesTab('酒店描述')" :class="[{'fl_des_tab_head_itemS':fl_des_tab_item=='酒店描述'},'fl_des_tab_head_item fl_des_tab_head_item2']">酒店描述</div>
              <div class="clearboth"></div>
            </div>
            <div class="fl_des_tab_body">
              <div v-show="fl_des_tab_item=='基础信息'" class="fl_dtb_item">
                <div @click="FLShowMapAddress()" class="fl_dtb_item_address">
                  <div class="fl_dtb_item_address_ad">
                    {{stadium_current_detail.address}}
                  </div>
                  <div class="fl_dtb_item_address_ic"></div>
                  <div class="clearboth"></div>
                </div>
                <div v-show="business_time_status" class="fl_dtb_item_business">
                  <div class="fl_dtb_item_business_title">营业时间</div>
                  <div v-html="stadium_current_detail.business_time" class="fl_dtb_item_business_conte"></div>
                </div>
                <div v-show="services_arr.length>0" class="fl_dtb_item_businessMS">
                  <div class="fl_dtb_item_businessMS_mm">
                    <div class="fl_dtb_item_business_title">酒店服务</div>
                    <div class="fl_dtb_item_servers_conte">
                      <div class="fl_dtbisc_block" :style="'width: calc(23vw * 1 * '+services_arr.length+');'">
                        <div v-for="(sa_item,sa_index) in services_arr" @click="clickServiceDesc(sa_item)" :class="[{'fl_dtbiscb_itemS':sa_item==fl_current_service_des},'fl_dtbiscb_item']">
                          <img class="fl_dtbiscb_item_img" :src="servicesimg[sa_item]" />
                          {{services[sa_item]}}
                          <img v-show="sa_item==fl_current_service_des" class="fl_dtbiscb_item_popup" src="../../assets/images/FLVersion/bubble.png" />
                        </div>
                      </div>
                      <div class="clearboth"></div>
                    </div>
                  </div>
                </div>
                <div v-show="services_arr.length>0" v-html="services_txt" class="fl_dtb_item_servers_conteTip"></div>
              </div>
              <div v-show="fl_des_tab_item=='预约规则'" v-html="stadium_current_detail.book_tip" class="fl_dtb_item_book_tip"></div>
              <div v-show="fl_des_tab_item=='酒店描述'" v-html="stadium_current_detail.introduce" class="fl_dtb_item_introduce"></div>
            </div>
          </div>
          <!--
            此处添加 v-show="desc_status" ：
            1、在ios环境中，此div层级较‘向上的gif图片’层级高，会导致点击gif图片会触发此div子元素函数方法，而无法触发gif真正的方法。
            2、因此加了此判断，当 desc_status 为 false 时，强制隐藏此 div 这样就不会出现误触的问题
            3、desc_status：此参数为弹出层的状态的参数，只要与弹出层状态保持一致即可，不是单独创建的新变量
          -->
          <div v-show="desc_status" class="desc_cont_close">
            <!-- 关闭弹窗 @click.stop.prevent="closeAllTemplate()" -->
            <div @click.stop.prevent="FLConcatconstServers()" class="desc_cont_close_close">
              <img src="../../assets/images/FLVersion/fl_wer.png" />
              客服
            </div>
            <div @click.stop.prevent="closeAllTemplateAndOrder()" class="desc_cont_close_submi">立即预约</div>
            <div class="clearboth"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频播放 -->
    <div v-show="showVideo" class="hotailVider">
      <video id="vide" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-video-player-type="h5"
        x5-video-player-fullscreen="true" preload="auto" style="background-color: #000000;"
        :src="viderUrl" autoplay="autoplay" loop="loop"></video>
    </div>
    <!-- 关闭按钮 -->
    <div @click.stop.prevent="swiperleft()" v-show="showVideo" class="hotailViderMask_close" >
      <img src="../../assets/images/base/video_close_white.png" />
    </div>
    <v-touch v-on:swipeleft="swiperleft" v-on:swiperight="swiperright">
      <div @click.stop.prevent="pauseVideo()" v-show="showVideo" class="hotailViderMask">
        <img v-show="showVideo_icon" src="../../assets/images/base/video_start.png" class="hotailViderMask_pause" /><!-- 暂停按钮 -->
      </div>
    </v-touch>
  </div>
</template>

<script>
  import {distance,getStValStatus,distancenum,sortArry} from '../../lib/utils.js'
  import stadiumDetailFunctionArea from '../subgroup/stadiumDetailFunctionArea.vue'
  export default {
    components:{
      'stadiumDetailFunctionArea':stadiumDetailFunctionArea,
    },
    data() {
      return {
        city:'',//默认城市
        stadium_list:[],//场馆列表
        stadium_current:{},//当前场馆
        stadium_current_detail:{},//当前场馆详情（请求getStadiumDetailVersionTwo接口）
        initialswipe:0,//swiper初始位置索引值
        loaded:false,//加载结束
        order_panel_status:false,//预约面板状态
        order_title_arr:[],//当前场馆有的运动类型
        order_title:'',//当前选中的健身类型
        order_fit_arr:[],//可预约健身日期
        order_yoga_arr:[],//可预约瑜伽日期
        order_yoga_arr_course:[],//当前选择的日期瑜伽课程
        imgstar:require('../../assets/images/base/star.png'),//评分(选中)
        imgstarno:require('../../assets/images/base/star_none.png'),//评分(未选中)
        desc_status:false,//介绍面板状态
        services_arr:[],
        services: {
          "101": "免费停车",
          "102": "收费停车",
          "103": "免费洗浴",
          "104": "收费洗浴",
          "105": "免费衣柜",
          "106": "收费衣柜",
          "107": "免费餐饮",
          "108": "收费餐饮",
          "109": "免费教练",
          "110": "收费教练",
          "111": "购物",
          "112": "WIFI",
          "113": "器具租赁",
          "114": "游泳池",
          "115": "力量器械",
          "116": "练操房",
          // "117": "住宿"
          "118":"限时免费停车",
        },
        servicesimg: {
          "101": require('../../assets/images/base/hotel_park.png'),
          "102": require('../../assets/images/base/hotel_park_money.png'),
          "103": require('../../assets/images/base/hotel_bathing.png'),
          "104": require('../../assets/images/base/hotel_bathing_money.png'),
          "105": require('../../assets/images/base/hotel_wardrobe.png'),
          "106": require('../../assets/images/base/hotel_wardrobe_money.png'),
          "107": require('../../assets/images/base/hotel_eating.png'),
          "108": require('../../assets/images/base/hotel_eating_money.png'),
          "109": require('../../assets/images/base/hotel_coach.png'),
          "110": require('../../assets/images/base/hotel_coach_money.png'),
          "111": require('../../assets/images/base/hotel_shopping.png'),
          "112": require('../../assets/images/base/hotel_wifi.png'),
          "113": require('../../assets/images/base/hotel_rent.png'),
          "114": require('../../assets/images/base/hotel_pool.png'),
          "115": require('../../assets/images/base/hotel_power_equipment.png'),
          "116": require('../../assets/images/base/hotel_practicehouse.png'),
          "118": require('../../assets/images/base/hotel_park.png'),
          // "117": "住宿"
        },
        business_time_status:false,//营业时间状态
        showVideo:false,//视频状态
        viderUrl:'',//视频链接
        showVideo_icon:false,//视频暂停icon
        services_txt:'',//服务类型的详细描述
        services_status:false,//服务类型状态
        services_settimeout:null,//服务类型定时器
        select_fit_date:null,//选择的健身日期
        select_fit_index:-1,//选择的健身索引
        select_yoga_date:null,//选择的瑜伽日期
        select_yoga_index:-1,//选择的瑜伽索引
        select_yoga_transform:0,//瑜伽课程日期默认往x轴偏移[2.2废弃，暂时不需要便宜，需要将所有的课程显示出来]
        current_yoga_course:null,//瑜伽课程
        sd_area_id:'',//场地id,健身下单需要
        user_card_list:[],//用户卡列表
        swiperTo_init:0,//点击gif,swiper需要跳转的地址

        recommend_toast:false,//是否显示过推荐提示
        default_fullpage_date:null,//默认全屏日期数据
        yogaoffset_secret:-1,//瑜伽偏移量最后的判断依据
        // ---v2.2---
        fl_des_tab_item:'基础信息',
        fl_current_service_des:'',//当前描述
        // fl_coursemodle:null,//当前瑜伽课[形式，制作数据展示]

        city_list:[],//城市列表
        is_filter:false,//是否过滤，保留包含瑜伽的酒店 true:瑜伽  false:健身
        fl_curYogaCourse:null,//选中可预约瑜伽课程

      }
    },
    created() { },
    mounted() {
      // this.getJsAuth()
      // this.gettostlist()
    },
    activated() {
      if(sessionStorage.getItem('fullpage')){
        this.initialswipe=JSON.parse(sessionStorage.getItem('fullpage'))
        sessionStorage.removeItem('fullpage')
        // // // // // console.log('没')
      }else{
        this.stadium_list=[]
        this.order_panel_status=false
        this.recommend_toast=false
        this.default_fullpage_date=null
        // 当从列表模式，判断是否需要过滤出瑜伽酒店
        if(sessionStorage.getItem('fullpage_filter_yoga')=='yes'){
          this.is_filter=true
          sessionStorage.removeItem('fullpage_filter_yoga')
        }else{
          this.is_filter=false
        }
        this.getRegion()
      }
      if(localStorage.getItem('token')){
        this.userCardList()
      }
      // 关闭弹框
      this.closeAllTemplate()
      // 重置video
      this.showVideo=false
      this.viderUrl=''

      document.title = '斐燃生活——畅享五星级奢华酒店游泳/健身/瑜伽';
      // sessionStorage.setItem('fullpage_filter_yoga','yes')

      var btn = document.getElementById('launch-btn');
      btn.addEventListener('launch', function (e) {
        // // // // console.log('success');
      });
      btn.addEventListener('error', function (e) {
        // // // // console.log('fail', e.detail);
      });
    },
    methods: {
      // 判断当前所在的区域并判断用户是否在所在的城市
      getRegion(){
        this.loaded=false
        var $this = this

        // console.log($this.$store.state.array_cityList)
        if($this.$store.state.array_cityList.length == 0){
          console.log(1)
          let param = {  }
          var qs = require('qs');
          let url = this.api.userApi.getCity
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            if (result.data) {
              $this.$store.commit('updataCityList',result.data.city)
              $this.city_list=result.data.city
              // $this.$store.commit('updateCityList',result.data.city)//设置
              if(localStorage.getItem('city')){
                $this.city=localStorage.getItem('city')
              }else{
                $this.city=result.data.city[0].name
              }
              $this.getStadium()
            } else {
              $this.city='上海'
              $this.getStadium()
            }
          }).catch((error) => {
            // // // // console.warn(error)
            $this.city='上海'
            $this.getStadium()
          })
        }else{
          console.log(2)
          var current = $this.$store.state.array_cityList

          $this.city_list=current
          // $this.$store.commit('updateCityList',result.data.city)//设置
          if(localStorage.getItem('city')){
            $this.city=localStorage.getItem('city')
          }else{
            $this.city=current[0].name
          }
          $this.getStadium()
        }



      },
      getStadium(){
        // 剔除已经加载过城市场馆数据
        for (var i = 0; i < this.city_list.length; i++) {
          if(this.city_list[i].name==this.city){
            // // // console.log(this.city_list[i].name)
            this.city_list.splice(i,1)
          }
        }
        var $this = this
        this.$loading('加载中~');
        // 获取日期模式下进入全屏页的页面日期数据
        if(sessionStorage.getItem('fullpage_date_mode')){
          $this.default_fullpage_date=JSON.parse(sessionStorage.getItem('fullpage_date_mode'))
        }
        this.gettostlist()
        return
      },
      gettostlist(){
        var $this = this
        var type=''
        // is_filter ==> true:瑜伽  false:健身
        if(this.is_filter==true){
          type=2
        }else{
          type=1
        }
        // // // // console.log(type)
        let param = {
          // city:$this.city,
          type:type,
          // date:this.reserves_date[this.order_date_index].date_complete
        }
        var qs = require('qs');
        let url = this.api.userApi.flStadiumLists
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // // console.log(result)
          $this.$loading.close()
          if (result.code==0) {
            var curPosition=localStorage.getItem('curPosition')
            for (var i = 0; i < result.data.stadiums.length; i++) {
              // 计算获取到酒店与自己的距离
              if(curPosition){
                result.data.stadiums[i].distance=distance((JSON.parse(curPosition)).latitude,(JSON.parse(curPosition)).longitude,result.data.stadiums[i].latitude,result.data.stadiums[i].longitude)
                result.data.stadiums[i].distancenum=distancenum((JSON.parse(curPosition)).latitude,(JSON.parse(curPosition)).longitude,result.data.stadiums[i].latitude,result.data.stadiums[i].longitude)
              }else{
                result.data.stadiums[i].distance=-1
                result.data.stadiums[i].distancenum=-1
              }
            }
            // 处理tag标签分开
            for (var i = 0; i < result.data.stadiums.length; i++) {
              if(getStValStatus(result.data.stadiums[i].tag).stat){
                result.data.stadiums[i].tag_arr=result.data.stadiums[i].tag.split(',')
              }else{
                result.data.stadiums[i].tag_arr=[]
              }
            }

            // 赋值
            $this.stadium_list=result.data.stadiums


            // var stadium_id=''
            for (var i = 0; i < result.data.stadiums.length; i++) {
              // // // // console.log(result.data.stadiums[i])
              // // // // console.log($this.$route.params.stadium_id)
              if($this.$route.params.stadium_id==result.data.stadiums[i].stadium_id){
                // // // console.log(result.data.stadiums[i])
                // stadium_id=result.data.stadiums[i].stadium_id
                $this.stadium_current=result.data.stadiums[i]
                $this.initialswipe=i
              }
            }

            $this.loaded=true
            // // // // console.log(stadium_sort)
            // 分享功能
            $this.shareStadium()
          } else {
            $this.stadium_list=[]
          }
        }).catch((error) => {
          // // // console.warn(error)
        })
      },
      // 垂直轮播，每一页轮播结束后触发
      verticalSwiper(e){
        var $this=this
        // // // console.log(e)

        // // // // console.log(this.$store.state.list_stadiums)

        this.closeAllTemplate()

        this.stadium_current=this.stadium_list[e]
        this.sd_area_id=''//清除上一次酒店的场馆id
        // // // // // console.log(this.city_list)
        if(e+1==this.stadium_list.length){
          this.$toast('更多五星酒店即将上线');
        }else{
          if(e>=1){
            // // // // console.log(this.stadium_list[e-1].city)
            // // // // console.log(this.stadium_current.city)
            if(this.stadium_list[e-1].city != this.stadium_current.city){

              if(this.recommend_toast==false){
                this.$toast('为您推荐其他城市');
                this.recommend_toast=true
              }

            }
          }
        }
        this.shareStadium()
        setTimeout(function(){
          $this.initialswipe=e
        },100)

      },
      // 打开预约面板前的判断
      toCreateOrder(){
        var $this = this
        // // // // // console.log(this.stadium_current)
        // // // // // console.log(this.stadium_current.name)
        // this.order_panel_status=!this.order_panel_status


        // 判断当前swiper的索引值
        this.$loading('正在加载');
        if(localStorage.getItem('token')){
          if($this.$store.state.object_userinfo==null){
            let param = {
              token: localStorage.getItem("token")
            }
            var qs = require('qs');
            let url = this.api.userApi.getInfo
            this.axios.post(url, qs.stringify(param), )
            .then((result) => {
              // // // // // console.log(result)
              if (result.data) {
                $this.$store.commit('updataMyInfo',result.data.user)
                if(getStValStatus(result.data.user.name).code==0){
                  // // // // console.log(result.data.user.name)
                  var init_swiper=0
                  for (var i = 0; i < $this.stadium_list.length; i++) {
                    if($this.stadium_current==$this.stadium_list[i]){
                      init_swiper=i
                    }
                  }
                  $this.$loading.close()
                  $this.$router.push({
                    name:'realname',
                    params:{
                      initialswipe:init_swiper
                    }
                  })
                }else{
                  // // // // // console.log('已经实名，继续下一步')
                  // // // // // console.log($this.stadium_current)
                  $this.$loading.close()
                  if($this.stadium_current.is_business==0 && getStValStatus($this.stadium_current.business_tip).stat==true){
                    this.$dialog.alert({
                      title: '温馨提示',
                      message: $this.stadium_current.business_tip,
                      confirmButtonColor: '#544590'
                    }).then(() => {

                    });
                    return
                  }
                  if(getStValStatus($this.stadium_current.business_tip).stat==true){
                    this.$dialog.alert({
                      title: '温馨提示',
                      message: $this.stadium_current.business_tip,
                      confirmButtonColor: '#544590'
                    }).then(() => {

                    });
                  }
                  $this.toCreateOrderOpen()
                }
              } else {
                $this.$loading.close()
                $this.$toast(result.msg)
                $this.$router.push({
                  name:'login'
                })
              }
            }).catch((error) => {
              // // // console.warn(error)
              $this.$loading.close()
              // $this.$toast('error');
              $this.$router.push({
                name:'login'
              })
            })
          }else{
            var currinfo=$this.$store.state.object_userinfo
            console.log(currinfo)
            if(getStValStatus(currinfo.name).code==0){
              // // // // console.log(result.data.user.name)
              var init_swiper=0
              for (var i = 0; i < $this.stadium_list.length; i++) {
                if($this.stadium_current==$this.stadium_list[i]){
                  init_swiper=i
                }
              }
              $this.$loading.close()
              $this.$router.push({
                name:'realname',
                params:{
                  initialswipe:init_swiper
                }
              })
            }else{
              // // // // // console.log('已经实名，继续下一步')
              // // // // // console.log($this.stadium_current)
              $this.$loading.close()
              if($this.stadium_current.is_business==0 && getStValStatus($this.stadium_current.business_tip).stat==true){
                this.$dialog.alert({
                  title: '温馨提示',
                  message: $this.stadium_current.business_tip,
                  confirmButtonColor: '#544590'
                }).then(() => {

                });
                return
              }
              if(getStValStatus($this.stadium_current.business_tip).stat==true){
                this.$dialog.alert({
                  title: '温馨提示',
                  message: $this.stadium_current.business_tip,
                  confirmButtonColor: '#544590'
                }).then(() => {

                });
              }
              $this.toCreateOrderOpen()
            }
          }

        }else{
          $this.$loading.close()
          this.$router.push({
            name:'login'
          })
        }
      },
      // 打开预约面板
      toCreateOrderOpen(){
        this.getCurrentAreaId()
        this.order_title_arr=[];//清空原来已加载的数据
        this.select_fit_date=null;//选择的健身日期
        this.select_fit_index=-1;//选择的健身索引
        this.select_yoga_date=null;//选择的瑜伽日期
        this.select_yoga_index=-1;//选择的瑜伽索引
        this.order_yoga_arr_course=[];//课程数据清空
        this.order_fit_arr=[];//可预约健身日期
        this.order_yoga_arr=[];//可预约瑜伽日期
        this.current_yoga_course=null;//瑜伽课程
        this.select_yoga_transform=0;//瑜伽课程日期默认往x轴偏移
        this.yogaoffset_secret=-1
        this.fl_curYogaCourse=null
        // this.fl_coursemodle=null
        this.$loading('正在加载');
        var $this = this
        let param = {
          token: localStorage.getItem("token"),
          stadium_id: this.stadium_current.stadium_id,
        }
        var qs = require('qs');
        let url = this.api.userApi.getFityogastocks
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // // console.log(result)
          // result.data.yoga[2].courses[0].order_cnt=2
          if (result.data) {
            if(result.data.fit==[]&&result.data.yoga==[]){
              $this.$toast('暂无服务，敬请期待')
              return
            }
            // 标题模块
            if(result.data.fit.length>0){//&&$this.user_card_list.length>0
              $this.order_title_arr.push('沸健身')
            }
            if(result.data.yoga.length>0){//&&$this.user_card_list.length>0
              $this.order_title_arr.push('翡瑜伽')
            }
            //初始化健身面板显示的健身类型
            if($this.is_filter==true){
              $this.order_title='翡瑜伽'
            }else{
              $this.order_title=$this.order_title_arr[0]
            }

            // ====沸健身====
            $this.order_fit_arr=result.data.fit
            /**
             * 初始状态下选中满足需求的日期：
             * 日期模式下的，若选中日期可预约，则选中；若不可预约，则从新开始选择第一个可预约的日期
             * 非日期模式下，选中第一个可预约的日期
             */
            if($this.default_fullpage_date==null||$this.default_fullpage_date=={}){
              if(result.data.fit.length>0){
                for (var i = 0; i < result.data.fit.length; i++) {
                  if(result.data.fit[i].free_cnt>0){
                    $this.select_fit_index=i
                    $this.select_fit_date=result.data.fit[i]
                    // // // console.log(i)
                    // // // console.log(result.data.fit[i])
                    break;
                  }
                }
              }
            }else{
              var default_fullpage_date_item=null
              for (var j = 0; j < result.data.fit.length; j++) {
                if(result.data.fit[j].date==$this.default_fullpage_date.date_complete){
                  default_fullpage_date_item=result.data.fit[j]
                  // // // console.log(result.data.fit[j])
                  break
                }
              }
              if(!default_fullpage_date_item){
                //当用户在17点之前进入预约列表，超过17点点击预约，就会获取不到对应的预约日期，默认第一个，防止页面弹层打不开
                // // // console.log(result.data.fit[0])
                default_fullpage_date_item=result.data.fit[0]
              }
              // // // console.log(default_fullpage_date_item)
              if(default_fullpage_date_item){
                if(default_fullpage_date_item.free_cnt>0){
                  for (var j = 0; j < result.data.fit.length; j++) {
                    if(result.data.fit[j].date==$this.default_fullpage_date.date_complete && result.data.fit[j].free_cnt > 0){
                      $this.select_fit_index=j
                      $this.select_fit_date=result.data.fit[j]
                      break
                    }
                  }
                }else{
                  for (var i = 0; i < result.data.fit.length; i++) {
                    if(result.data.fit[i].free_cnt>0){
                      $this.select_fit_index=i
                      $this.select_fit_date=result.data.fit[i]
                      break;
                    }
                  }
                }
              }
            }
            if($this.select_fit_index>=0){
              var offset_left=0
              offset_left=$this.select_fit_index+3
              if(offset_left+1>=result.data.fit.length){
                offset_left=result.data.fit.length-1
              }
              var anchor='anchor'+offset_left
              // 健身模块偏移
              setTimeout(function(){
                $this.$el.querySelector('#'+anchor).scrollIntoView();
              },500)
            }

            // ====翡瑜伽====
            /**
             *  存在瑜伽日期数据
             *    1、瑜伽日期数组赋值
             *    2、当前瑜伽课程数组赋值
             *    3、获取当前日期年月日
             *    4、没有全屏页可预约日期信息
             *       4-1、瑜伽日期偏移量[用于隐藏当天之前的瑜伽日期]
             *       4-2、赋值当前瑜伽日期索引、瑜伽日期、瑜伽课程并将当前瑜伽课程设置为null
             *    5、存在全屏页可预约日期信息
             *       5-1、瑜伽日期偏移量[用于隐藏当天之前的瑜伽日期]
             *       5-2、若瑜伽可预约日期与全屏页相同，赋值当前瑜伽日期索引、瑜伽日期、瑜伽课程并将当前瑜伽课程设置为null
             *       5-3、若瑜伽可预约日期与全屏页不同，则将根据当前日期为起点，找到未来可预约的日期和课程
             *
             */
            if(result.data.yoga.length>0){
              // 瑜伽列表
              $this.order_yoga_arr=result.data.yoga

              $this.order_yoga_arr_course=result.data.yoga[0].courses

              var pdate=new Date()
              var pdate_year=pdate.getFullYear()
              var pdate_month=pdate.getMonth()+1
              if(pdate_month<10){pdate_month='0'+pdate_month}
              var pdate_date=pdate.getDate()
              if(pdate_date<10){pdate_date='0'+pdate_date}
              var sdate=pdate_year+'-'+pdate_month+'-'+pdate_date
              // // // console.log(sdate)

              /**
               * default_fullpage_date
               * 1.null：没有全屏页可预约日期信息
               * 2.!null：存在全屏页可预约日期信息
               */
              // // // console.log($this.default_fullpage_date)
              if($this.default_fullpage_date==null||$this.default_fullpage_date=={}){
                // // // console.log('9527')
                for (var i = 0; i < result.data.yoga.length; i++) {
                  if(result.data.yoga[i].date==sdate){
                    // // // // console.log(i)
                    // // // // console.log(result.data.yoga[i].date)
                    $this.select_yoga_transform=i

                    for (var j = i; j < result.data.yoga.length; j++) {
                      if(result.data.yoga[j].courses.length!=0){
                        // // // // console.log(j)
                        $this.select_yoga_index=j
                        // $this.select_yoga_transform=j
                        $this.select_yoga_date=result.data.yoga[j]
                        $this.order_yoga_arr_course=result.data.yoga[j].courses
                        $this.current_yoga_course=null
                        break;
                      }
                    }
                    // // // // console.log($this.order_yoga_arr_course)
                  }
                }
              }else{
                for (var i = 0; i < result.data.yoga.length; i++) {
                  // // // console.log(result.data.yoga[i])
                  if(result.data.yoga[i].date==sdate){
                    $this.select_yoga_transform=i
                  }
                  if(result.data.yoga[i].date==$this.default_fullpage_date.date_complete){
                    // // // // console.log(i)
                    // // // // console.log(result.data.yoga[i].date)
                    // // // console.log(result.data.yoga[i])
                    for (var j = i; j < result.data.yoga.length; j++) {
                      if(result.data.yoga[j].date==$this.default_fullpage_date.date_complete){
                        if(result.data.yoga[j].courses.length!=0){
                          // // // // console.log(j)
                          // // // // console.log(result.data.yoga[j])
                          $this.select_yoga_index=j
                          $this.select_yoga_date=result.data.yoga[j]
                          $this.order_yoga_arr_course=result.data.yoga[j].courses
                          $this.current_yoga_course=null
                          break;
                        }else{
                          $this.select_yoga_index=-1
                          $this.yogaoffset_secret=j
                          $this.select_yoga_date=null
                          $this.order_yoga_arr_course=[]
                          $this.current_yoga_course=null
                        }
                      }
                    }
                  }
                }
                if($this.select_yoga_index==-1){
                  for (var j = 0; j < result.data.yoga.length; j++) {
                    var tdate=sdate.replace(/-/g,"/")
                    var pdate=result.data.yoga[j].date.replace(/-/g,"/")
                    if(result.data.yoga[j].courses.length>0 && new Date(pdate).getTime()>=new Date(tdate).getTime()){
                      $this.select_yoga_index=j
                      $this.select_yoga_date=result.data.yoga[j]
                      $this.order_yoga_arr_course=result.data.yoga[j].courses
                      $this.current_yoga_course=null
                      break
                    }
                  }
                }
              }
            }
            // // // console.log($this.select_yoga_index)
            // // // console.log($this.select_yoga_date)
            // // // console.log($this.order_yoga_arr_course)

            // 根据当前选中的日期，默认滚动到可是区域
            if($this.select_yoga_index>=0){
              var offset_left=0
              offset_left=$this.select_yoga_index+3
              if(offset_left+1>=result.data.yoga.length){
                offset_left=result.data.yoga.length-1
              }
              var anchoryoga='anchoryoga'+offset_left
              // // // // console.log(anchoryoga)
              // 瑜伽模块偏移
              setTimeout(function(){
                $this.$el.querySelector('#'+anchoryoga).scrollIntoView();
              },500)
            }else{
              if($this.yogaoffset_secret>0){
                var anchoryoga='anchoryoga'+$this.yogaoffset_secret
                // // // // console.log(anchoryoga)
                // 瑜伽模块偏移
                setTimeout(function(){
                  $this.$el.querySelector('#'+anchoryoga).scrollIntoView();
                },500)
              }
            }
            // 初始化当前日期的课程，判断有些课程是否已经过了预约日渐
            if($this.order_yoga_arr_course.length>0){
              for (var i = 0; i < $this.order_yoga_arr_course.length; i++) {
                // // // // console.log($this.order_yoga_arr_course[i])
                // // // // console.log($this.order_yoga_arr_course[i].start_time)

                var coursertime=(($this.order_yoga_arr_course[i].start_time).substring(0,10)).replace(/-/g,'/')
                // console.log(coursertime)
                // // // // console.log(new Date(coursertime).setHours(0,0,0,0))
                // // // // console.log(new Date().setHours(0,0,0,0))
                if(new Date(coursertime).setHours(0,0,0,0)>new Date().setHours(0,0,0,0)){
                  $this.order_yoga_arr_course[i].over_order_time=1//未到预约截止时间
                }else if(new Date(coursertime).setHours(0,0,0,0)==new Date().setHours(0,0,0,0)){
                  // $this.order_yoga_arr_course[i].over_order_time=0//已经到预约截止时间

                  var over_order_time_pre=new Date(($this.order_yoga_arr_course[i].start_time).replace(/-/g,'/')).getTime()-0*60*60*1000
                  var over_order_time_pret=new Date(($this.order_yoga_arr_course[i].start_time).replace(/-/g,'/')).getTime()-3*60*60*1000
                  // 24*60*60*1000
                  // // // // console.log()
                  // {{current_yoga_course.order_cnt}}/{{current_yoga_course.galleryful}}
                  if(over_order_time_pre>new Date().getTime()){

                    if(over_order_time_pret<=new Date().getTime() && $this.order_yoga_arr_course[i].order_cnt==0){
                      $this.order_yoga_arr_course[i].over_order_time=0//开课前3小时依然没有人预约
                    }else{
                      $this.order_yoga_arr_course[i].over_order_time=1//开课前3小时依然有人预约
                    }
                  }else{
                    $this.order_yoga_arr_course[i].over_order_time=0//已经到预约截止时间
                  }
                }else{
                  $this.order_yoga_arr_course[i].over_order_time=0//已经到预约截止时间
                }
              }
            }
            // console.log($this.order_yoga_arr_course)

            // // // console.log($this.current_yoga_course)
            // // // console.log($this.order_yoga_arr_course[0])
            // // // console.log($this.order_yoga_arr_course)
            // // // // console.log($this.fl_coursemodle)
            // var anchoryogacourseN=0
            $this.current_yoga_course=$this.order_yoga_arr_course[0]
            if($this.order_yoga_arr_course.length>0){
              for (var i = 0; i < $this.order_yoga_arr_course.length; i++) {
                if($this.order_yoga_arr_course[i].over_order_time==1 && $this.order_yoga_arr_course[i].galleryful - $this.order_yoga_arr_course[i].order_cnt>0){
                  $this.fl_curYogaCourse=$this.order_yoga_arr_course[i]
                  $this.current_yoga_course=$this.order_yoga_arr_course[i]
                  // anchoryogacourseN=i
                  break;
                }
              }
            }
            // // // console.log(anchoryogacourseN)
            // var anchurse='anchoryogacourse'+anchoryogacourseN
            // // // console.log(anchurse)
            // setTimeout(function(){
            //   // // // console.log('滚动'+anchurse+'到可视区域')
            //   $this.$el.querySelector('#'+anchurse).scrollIntoView();
            // },500)
            // :id="'anchoryogacourse'+oyac_index"
            setTimeout(function(){
              $this.$loading.close()
              // 弹框状态
              $this.order_panel_status=!$this.order_panel_status
            },500)
          } else {
            $this.$loading.close()
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          // // // console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })
        // ==================================================================================================

      },
      // 获取场馆id ==> sd_area_id
      getCurrentAreaId(){
        var $this=this
        let param = {
          token: localStorage.getItem("token"),
          stadium_id: this.stadium_current.stadium_id,
        }
        var qs = require('qs');
        let url = this.api.userApi.getStadiumDetailVersionTwo
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // // // console.log(result)
          if (result.data) {
            $this.sd_area_id=result.data.fit_service_id
          }
        }).catch((error) => {
          // // // console.warn(error)
        })
      },
      // 切换选择健身标题
      switchOrderTitle(title){
        var $this=this
        this.order_title=title//切换健身类型
        // // // // // console.log(title)
        if($this.select_fit_index>=0){
          var offset_left=0
          // if($this.select_fit_index==0){
          //   offset_left=$this.select_fit_index
          // }else if($this.select_fit_index>0 && $this.select_fit_index<6){
          //   offset_left=$this.select_fit_index+3
          // }else{
          //   offset_left=$this.order_fit_arr.length-1
          // }
          offset_left=$this.select_fit_index+3
          if(offset_left+1>=$this.order_fit_arr.length){
            offset_left=$this.order_fit_arr.length-1
          }

          var anchor='anchor'+offset_left
          // $this.$refs.anchor.scrollIntoView()
          // 健身模块偏移
          setTimeout(function(){
            $this.$el.querySelector('#'+anchor).scrollIntoView();
          },0)
        }
        if($this.select_yoga_index>=0){
          var offset_left=0
          // if($this.select_yoga_index==0){
          //   offset_left=$this.select_yoga_index
          // }else{
          //   offset_left=$this.select_yoga_index+3
          // }
          // if(offset_left>$this.order_yoga_arr.length){
          //   offset_left=$this.order_yoga_arr.length
          // }
          // offset_left=offset_left-$this.select_yoga_transform+1
          // // // // console.log($this.order_yoga_arr.length)
          offset_left=$this.select_yoga_index+3

          if(offset_left+1>=$this.order_yoga_arr.length){
            offset_left=$this.order_yoga_arr.length-1
          }

          var anchoryoga='anchoryoga'+offset_left
          // // // // console.log(anchoryoga)
          // 瑜伽模块偏移
          setTimeout(function(){
            $this.$el.querySelector('#'+anchoryoga).scrollIntoView();
          },0)

        }else{
          if($this.yogaoffset_secret>0){
            var anchoryoga='anchoryoga'+$this.yogaoffset_secret
            // // // // console.log(anchoryoga)
            // 瑜伽模块偏移
            setTimeout(function(){
              $this.$el.querySelector('#'+anchoryoga).scrollIntoView();
            },0)
          }
        }
      },
      // 点击按钮
      switchUpArrow(){
        this.swiperTo_init=this.initialswipe
        if(this.initialswipe+1<this.stadium_list.length){
          this.swiperTo_init+=1
          this.$refs.swiper.swipeTo(this.swiperTo_init)
          this.verticalSwiper(this.initialswipe)
        }else{
          this.$toast('更多五星酒店即将上线');
        }

      },
      // 选择健身日期
      selectFitDate(item,index){
        // // // // console.log(item)
        // // // // console.log(index)
        if(item.free_cnt>0){
          this.select_fit_index=index
          this.select_fit_date=item
        }
      },
      // 关闭弹层
      closeAllTemplate(){
        this.order_panel_status=false;//关闭预约弹层
        this.desc_status=false
      },
      // 关闭弹框并预约
      closeAllTemplateAndOrder(){
        this.closeAllTemplate()
        this.toCreateOrder()
      },
      // 选择日期课程
      selectCourse(item,index){
        console.log(item)

        if(item.courses.length >0){

          // // // console.log(item.courses)
          if(item.courses.length>0){
            for (var i = 0; i < item.courses.length; i++) {
              var coursertime=((item.courses[i].start_time).substring(0,10)).replace(/-/g,'/')
              if(new Date(coursertime).setHours(0,0,0,0)>new Date().setHours(0,0,0,0)){
                item.courses[i].over_order_time=1//未到预约截止时间
                // console.log('未到预约截止时间')
              }else if(new Date(coursertime).setHours(0,0,0,0)==new Date().setHours(0,0,0,0)){
                // var over_order_time_pre=parseInt((item.courses[i].start_time).substring(11,13),10)-3
                var over_order_time_pre=new Date((item.courses[i].start_time).replace(/-/g,'/')).getTime()-0*60*60*1000
                var over_order_time_pret=new Date((item.courses[i].start_time).replace(/-/g,'/')).getTime()-3*60*60*1000
                if(over_order_time_pre>new Date().getTime()){

                  if(over_order_time_pret<=new Date().getTime() && item.courses[i].order_cnt==0){
                    item.courses[i].over_order_time=0//未到预约截止时间
                  }else{
                    item.courses[i].over_order_time=1//未到预约截止时间
                  }
                }else{
                  item.courses[i].over_order_time=0//已经到预约截止时间
                }
              }else{
                item.courses[i].over_order_time=0//已经到预约截止时间
              }
            }
            console.log(item.courses)
          }
          this.select_yoga_index=index
          this.select_yoga_date=item
          this.order_yoga_arr_course=item.courses

          console.log(item.courses)
          this.current_yoga_course=item.courses[0];//清空课程数据
          if(item.courses.length==1){
            if(item.courses[0].order_cnt>=item.courses[0].galleryful){
              this.fl_curYogaCourse=null
              console.log(1)
            }else{

              if(item.courses[0].over_order_time==0){
                this.fl_curYogaCourse=null
              }else{
                this.fl_curYogaCourse=item.courses[0]
              }
              console.log(2)
            }
          }else{
            this.fl_curYogaCourse=null

            console.log(3)
            // console.log(item.courses)
            for (var i = 0; i < item.courses.length; i++) {
              if(item.courses[i].order_cnt<item.courses[i].galleryful && item.courses[i].over_order_time==1){
                // 距离开课时间大于3小时
                if(new Date((item.courses[i].start_time).replace(/-/g,'/')).getTime() - 3*60*60*1000 > new Date().getTime()){
                  this.fl_curYogaCourse=item.courses[i]
                  this.current_yoga_course=item.courses[i];
                  // console.log(item.courses[i])
                  break
                }
                // 距离开课时间不足3小时、未到开课时间的、已有人预约课程的
                if(new Date((item.courses[i].start_time).replace(/-/g,'/')).getTime() - 0*60*60*1000 > new Date().getTime() && item.courses[i].order_cnt > 0){
                  this.fl_curYogaCourse=item.courses[i]
                  this.current_yoga_course=item.courses[i];
                  // console.log(item.courses[i])
                  break
                }

              }
            }
            // console.log(this.fl_curYogaCourse)
          }

          // this.fl_coursemodle=item.courses[0]
        }
      },
      // 选择具体课程
      selectYogaCourse(item){
        console.log(item)
        this.fl_curYogaCourse=null;
        // return
        this.current_yoga_course=item

        // {{current_yoga_course.galleryful-current_yoga_course.order_cnt}}

        if(item.over_order_time==0){
          this.fl_curYogaCourse=null;
          console.log(1)
        }else{
          if(item.galleryful - item.order_cnt<=0){
            this.fl_curYogaCourse=null;
            console.log(2)
          }else{
            console.log(3)
            if(new Date((item.start_time).replace(/-/g,'/')).getTime() - 3*60*60*1000 > new Date().getTime()){
              this.fl_curYogaCourse=item
              this.current_yoga_course=item;
              // console.log(item)
              // break
            }
            if(new Date((item.start_time).replace(/-/g,'/')).getTime() - 0*60*60*1000 > new Date().getTime() && item.order_cnt > 0){
              this.fl_curYogaCourse=item
              this.current_yoga_course=item;
              // console.log(item)
              // break
            }
            // this.fl_curYogaCourse=item
          }

        }
        // // // console.log(this.fl_curYogaCourse)
      },
      // 打开介绍面板
      toOpenDesc(){
        var $this=this
        this.fl_des_tab_item='基础信息'
        // return
        let param = {
          token: localStorage.getItem("token"),
          stadium_id: this.stadium_current.stadium_id,
        }
        var qs = require('qs');
        let url = this.api.userApi.getStadiumDetailVersionTwo
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // // // console.log(result.data.introduce)
          // // // console.log(result.data)
          if (result.data) {
            $this.desc_status=true
            var services=[]
            if(result.data.service==null||result.data.service==''||result.data.service==undefined){
              services=[]
            }else{
              services=result.data.service.split(',')
            }
            // console.log(services)
            if(services.length>0){
              $this.fl_current_service_des=services[0]
            }
            // // // console.log($this.fl_current_service_des)
            $this.services_arr=services
            $this.business_time_status=getStValStatus(result.data.business_time).stat
            // desc_status
            $this.stadium_current_detail=result.data

            // // // console.log($this.stadium_current_detail.service_des)
            if($this.stadium_current_detail.service_des){
              // // // console.log(JSON.parse($this.stadium_current_detail.service_des))

              if(JSON.parse($this.stadium_current_detail.service_des)[$this.fl_current_service_des]){
                $this.services_txt=JSON.parse($this.stadium_current_detail.service_des)[$this.fl_current_service_des]
              }else{
                $this.services_txt='暂无'
              }
            }else{
              $this.services_txt='暂无'
            }


          } else {
            $this.$loading.close()
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          // // // console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })

      },
      // 打开视频播放
      toOpenVideo(){
        // // // // console.log(this.stadium_current)
        this.showVideo=true
        this.viderUrl=this.stadium_current.env_video
        // // // // console.log(this.stadium_current.env_video)
        this.showVideo_icon=false

        // 打开视频后，再执行播放，若不执行此操作，会导致在安卓部分机型中出现黑屏不播放情况，再次点击才会正常播放
        var vide = document.getElementById("vide")
        vide.play();
        // setTimeout(function(){
        //   $this.viderUrl='http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'//this.stadium_current.env_video
        // },1000)
      },
      // 视频左划
      swiperleft(){
        this.stopVideo()
      },
      // 视频右划
      swiperright(){
        this.stopVideo()
      },
      // 关闭视频
      stopVideo() {
        var vide = document.getElementById("vide")
        vide.pause();
        this.viderUrl = ''
        this.showVideo=false
        this.showVideo_icon=false
      },
      // 暂停视频
      pauseVideo(){
        var vide = document.getElementById("vide")
        if (vide.paused) {
          vide.play();
          this.showVideo_icon=false
        } else {
          vide.pause();
          this.showVideo_icon=true
        }
      },
      // 获取当前服务类型的详细描述
      clickServiceDesc(item){
        var $this=this
        // // // // console.log(item)
        this.fl_current_service_des=item
        // // // // console.log(this.stadium_current_detail.service_des)
        if(!this.stadium_current_detail.service_des){
          this.services_txt='暂无'
          return
        }

        if(JSON.parse(this.stadium_current_detail.service_des)[item]){

          if(JSON.parse(this.stadium_current_detail.service_des)[item]){
            this.services_txt=JSON.parse(this.stadium_current_detail.service_des)[item]
          }else{
            this.services_txt='暂无'
          }
        }else{
          this.services_txt='暂无'
        }

        // // // console.log(JSON.parse(this.stadium_current_detail.service_des))
        // // // console.log(item)
        return
        // clearTimeout(this.services_settimeout)
        // // // // console.log(this.stadium_current_detail)
        // this.services_txt=JSON.parse(this.stadium_current_detail.service_des)[item]

        // this.services_status=getStValStatus(JSON.parse(this.stadium_current_detail.service_des)[item]).stat
        // this.services_settimeout=setTimeout(function(){
        //   $this.services_status=false
        // },5000);
      },
      // 判断用户是否在黑名单中
      tocreateOrderO(){
        // // // // console.log(this.stadium_current.stadium_id)
        // getBlacklist
        var $this=this;
        var param={
          token: localStorage.getItem("token"),
          stadium_id:this.stadium_current.stadium_id
        }
        var qs = require('qs');
        let url = this.api.userApi.getBlacklist
        this.axios.post(url,qs.stringify(param),)
        .then((res) => {
          // // // // console.log(res)
          if (res.data) {
            if(res.data.is_in_blacklist==0){
              $this.tocreateOrderWhiteList()
            }else{
              $this.$toast('抱歉，您暂时无法使用该健身礼遇，请详询客服服务热线。')
            }
          } else {
            $this.$toast(res.msg)
          }
        }).catch((error) => {
          // // // console.warn(error)
          $this.$toast(res.msg);
        })
      },
      // 健身去创建订单
      tocreateOrderWhiteList(){
        var $this=this
        // // // console.log(this.stadium_current)
        // // // console.log(this.select_fit_date)
        // return
        if(this.select_fit_date==null){
          this.$toast('请选择健身日期')
        }else{
          this.$loading('加载订单信息')
          // // // // console.log(getStValStatus(this.sd_area_id))
          if(getStValStatus(this.sd_area_id).stat==false){
            this.$toast('请再次点击预约')
            return
          }
          // // // console.log(this.stadium_current)
          // return
          sessionStorage.setItem('sd_area_id',this.sd_area_id);//创建订单：场馆id,健身下单需要
          sessionStorage.setItem('create_order_type','fit');//创建订单：类型
          sessionStorage.setItem('stadium_current',JSON.stringify(this.stadium_current));//创建订单：当前场馆信息
          sessionStorage.setItem('select_fit_date',JSON.stringify(this.select_fit_date));//创建订单：健身日期
          for (var i = 0; i < this.stadium_list.length; i++) {
            if(this.stadium_list[i].stadium_id==this.stadium_current.stadium_id){
              // // // // console.log(i)
              sessionStorage.setItem('fullpage',i)
            }
          }
          // stadium_list
          // return
          // user_card_list
          setTimeout(function(){
            $this.$loading.close()
            if($this.user_card_list.length>0){
              $this.$router.push({
                name:'createorder',
              })
            }else{
              $this.$router.push({
                name:'createordernocard',
              })
            }
          },500)
        }
      },
      // 判断用户是否在黑名单中（瑜伽）
      yogaToCreateOrder(){
        // // // // console.log(this.stadium_current.stadium_id)
        // getBlacklist
        var $this=this;
        var param={
          token: localStorage.getItem("token"),
          stadium_id:this.stadium_current.stadium_id
        }
        var qs = require('qs');
        let url = this.api.userApi.getBlacklist
        this.axios.post(url,qs.stringify(param),)
        .then((res) => {
          // // // console.log(res)
          if (res.data) {
            if(res.data.is_in_blacklist==0){
              $this.yogaToCreateOrderWhiteList()
            }else{
              $this.$toast('抱歉，您暂时无法使用该健身礼遇，请详询客服服务热线。')
            }
          } else {
            $this.$toast(res.msg)
          }
        }).catch((error) => {
          // // // console.warn(error)
          $this.$toast(res.msg);
        })
      },
      // 健身去创建订单（瑜伽）
      yogaToCreateOrderWhiteList(){
        var $this=this
        // // // // console.log(this.stadium_current)
        // // // // console.log(this.select_yoga_date)

        if(this.select_yoga_date==null || this.fl_curYogaCourse==null){
          this.$toast('请选择瑜伽日期和课程')
        }else{
          if($this.user_card_list.length==0){
            $this.$dialog.confirm({
              title:'温馨提示',
              message: "成为《斐燃会员》即可下单瑜伽课程",
              confirmButtonColor: '#544590',
              confirmButtonText:'成为会员',
              cancelButtonText:'再想想'
            }).then(() => {
              $this.$router.push({
                name:'vip'
              })
            }).catch(() => {

            })
            return
          }
          // // // console.log(this.fl_curYogaCourse)
          var coursertime=((this.fl_curYogaCourse.start_time).substring(0,10)).replace(/-/g,'/')
          // var over_order_time_pre=parseInt((this.fl_curYogaCourse.start_time).substring(11,13),10)-3
          var over_order_time_pre=new Date((this.fl_curYogaCourse.start_time).replace(/-/g,'/')).getTime()-3*60*60*1000
          if(over_order_time_pre<=new Date().getHours()&& new Date(coursertime).setHours(0,0,0,0)<=new Date().setHours(0,0,0,0)){
            this.$toast('亲  已过预约时间了哦')
            return
          }


          this.$loading('加载订单信息')
          // $this.user_card_list
          sessionStorage.setItem('create_order_type','yoga');//创建订单：类型
          sessionStorage.setItem('stadium_current',JSON.stringify(this.stadium_current));//创建订单：当前场馆信息
          sessionStorage.setItem('select_yoga_date',JSON.stringify(this.select_yoga_date));//创建订单：瑜伽日期
          sessionStorage.setItem('current_yoga_course',JSON.stringify(this.fl_curYogaCourse));//创建订单：瑜伽课程
          for (var i = 0; i < this.stadium_list.length; i++) {
            if(this.stadium_list[i].stadium_id==this.stadium_current.stadium_id){
              // // // // console.log(i)
              sessionStorage.setItem('fullpage',i)
            }
          }
          setTimeout(function(){
            $this.$loading.close()
            $this.$router.push({
              name:'createorder'
            })
          },500)
        }
      },
      // 获取用户会员卡列表
      userCardList(){
        var $this = this
        if($this.$store.state.array_mycard.length==0){
          let param = {
            token: localStorage.getItem("token"),
          }
          var qs = require('qs');
          let url = this.api.userApi.flUserCardsList
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            // // // console.log(result)
            if (result.code == 0) {
              if(result.data){
                if(result.data.length>0){
                  $this.user_card_list=result.data
                  $this.$store.commit('updataMycard',result.data)
                }else{
                  $this.user_card_list=[]
                  $this.$store.commit('updataMycard',[])
                }

              }else{
                $this.user_card_list=[]
                $this.$store.commit('updataMycard',[])
              }
              // // // console.log(result.data)
              // $this.$store.commit('setMyCards',result.data.cards)
            } else {
              // $this.$toast(result.msg)
            }
          }).catch((error) => {
            // // // console.warn(error)
            // $this.$toast('error');
          })
        }else{
          $this.user_card_list=$this.$store.state.array_mycard
        }


      },
      // 分享当前酒店
      // 分享模块
      getJsAuth() {
        // getJsAuth
        let that = this;
        var param = {
          url: encodeURIComponent(window.location.href)//location.href.split('#')[0]//encodeURIComponent(window.location.href)
        }
        var qs = require('qs');
        let url = this.api.userApi.getJsAuth
        this.axios.post(url, qs.stringify(param), )
        .then((res) => {
          // // // // // console.log(res)
          wx.config({
            debug: false,
            appId: res.data.appid, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature,
            jsApiList: [
              'getLocation',
              'updateAppMessageShareData', //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
              'updateTimelineShareData', //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
              'onMenuShareTimeline', //分享到朋友圈 老接口
              'onMenuShareAppMessage', //分享给盆友 老接口
            ]
          });
          wx.ready(function() {
            // that.shareStadium()
          });
        }).catch((error) => {
          // // // console.warn(error)
          that.$toast(error);
        })
      },
      shareStadium(){
        // // // // console.log(location.href.split('-')[0])
        let that = this;

        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          wx.updateAppMessageShareData({
            title: that.stadium_current.name, // 分享标题
            desc: '精选五星级奢华酒店健身等您来约！', //分享描述
            link: location.href.split('-')[0]+'-'+that.stadium_current.stadium_id, // 分享链接
            imgUrl: that.stadium_current.thumb, // 分享图标
            success(res) {
              // alert('updateAppMessageShareData')
              // // // // console.log(res)
            },
            fail(){
              // alert('fail updateAppMessageShareData')
            }
          });
          wx.updateTimelineShareData({
            title: that.stadium_current.name, // 分享标题
            link: location.href.split('-')[0]+'-'+that.stadium_current.stadium_id, // 分享链接
            imgUrl: that.stadium_current.thumb, // 分享图标
            success(res) {
              // // // // console.log(res)
              // alert('updateTimelineShareData')
            },
            fail(){
              // alert('fail updateTimelineShareData')
            }
          });
        } else {
          wx.onMenuShareAppMessage({
            title: that.stadium_current.name, // 分享标题
            desc: '精选五星级奢华酒店健身等您来约！', //分享描述
            link: location.href.split('-')[0]+'-'+that.stadium_current.stadium_id, // 分享链接
            imgUrl: that.stadium_current.thumb, // 分享图标
            success(res) {
              // // // // console.log(res)
              // alert('onMenuShareAppMessage')
            },
            fail(){
              // alert('fail onMenuShareAppMessage')
            }
          });
          wx.onMenuShareTimeline({
            title: that.stadium_current.name, // 分享标题
            link: location.href.split('-')[0]+'-'+that.stadium_current.stadium_id, // 分享链接
            imgUrl: that.stadium_current.thumb, // 分享图标
            success(res) {
              // // // // console.log(res)
              // alert('onMenuShareTimeline')
            },
            fail(){
              // alert('fail onMenuShareTimeline')
            }
          });
        }
        // return



        // var param = {
        //   url: location.href.split('-')[0]
        // }
        // var qs = require('qs');
        // let url = this.api.userApi.getJsAuth
        // this.axios.post(url, qs.stringify(param), )
        // .then((res) => {
        //   // // // // console.log(res)
        //   // // // // console.log(that.stadium_current)
        //   wx.config({
        //     debug: false,
        //     appId: res.data.appid, // 必填，公众号的唯一标识
        //     timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        //     nonceStr: res.data.noncestr, // 必填，生成签名的随机串
        //     signature: res.data.signature,
        //     jsApiList: [
        //       'getLocation',
        //       'updateAppMessageShareData', //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
        //       'updateTimelineShareData', //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
        //       'onMenuShareTimeline', //分享到朋友圈 老接口
        //       'onMenuShareAppMessage', //分享给盆友 老接口
        //     ]
        //   });
        //   wx.ready(function() {
        //   });
        // }).catch((error) => {
        //   // // // console.warn(error)
        //   that.$toast(error);
        // })

      },

      //---2.2---
      // 切换酒店介绍tabs
      FLSelectDesTab(item){
        if(this.fl_des_tab_item!=item){
          // // // console.log(item)
          this.fl_des_tab_item=item
        }
      },
      // 点击地址前往地图
      FLShowMapAddress(){
        // // // console.log(this.stadium_current_detail)
        window.location.href="https://apis.map.qq.com/tools/routeplan/eword="+this.stadium_current_detail.name+"&epointx="+this.stadium_current_detail.latitude+"&epointy="+this.stadium_current_detail.longitude+"?referer=Swimming&key=7YMBZ-22PWS-GMAOG-6OKK7-73XDF-BHFWC"
      },
      // 连接客服
      FLConcatconstServers(){
        window.qimoChatClick()
      },
      // 前往黑金小程序
      FLShowBlackVip(){
        var $this = this
        this.$dialog.confirm({
          // title:'温馨提示',
          message: "尊敬的用户，开通斐燃黑金会员，每天都可以免费预约全国奢华星级酒店，还有免费双人自助餐专享福利～",
          confirmButtonText:'去了解',
          confirmButtonColor:'#A5865F',
          cancelButtonText:'再逛逛',
          cancelButtonColor:'#666666'
        }).then(() => {
          // this.$toast("退订成功")
        }).catch(() => {

        })
      },
      //
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .res_head{
  	position:relative;
  	z-index:12;
  	width:100%;
  	height:100*@vm_base;
  }
  .res_head__fixed{
  	position:fixed;
  	left:0;
  	top:0;
  	z-index:99;
  	background:#fff;
  	width:100%;
  	height:100*@vm_base;
  	.res_head__fixed__box{
  		display:flex;
  		width:100%;
  		height:100%;
  	}
  	.res_header__fixed__left,
  	.res_header__fixed__right{
  		width: 90*@vm_base;
  		height:100%;
  	}
  	.res_header__fixed__center{
  		width: calc(100% - 180*@vm_base);
  		height:100%;
  		// line-height:100*@vm_base;
  		text-align:center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  		.enname{
  		  width: 100%;
  		  color: #000000;
  		  text-align: center;
  		  font-size: 32*@vm_base;
  		  height: 40*@vm_base;
  		  line-height: 40*@vm_base;
  		  margin-top: 20*@vm_base;
  		  letter-spacing: 8*@vm_base;
  		}
  		.chname{
  		  width: 100%;
  		  color: #000000;
  		  text-align: center;
  		  font-size: 24*@vm_base;
  		  height: 24*@vm_base;
  		  line-height: 24*@vm_base;
  		  margin-top: 4*@vm_base;
  		}
  	}
    .back{
      float:left;
      width:80*@vm_base;
      height:100%;
      background:url(../../assets/images/base/nav_back.png) center center no-repeat;
      background-size:18*@vm_base auto;
    }
    .res_switch{
      float:right;
      width:80*@vm_base;
      height:100%;
      background:url(../../assets/images/base/Switch_photo.png) center center no-repeat;
      background-size:38*@vm_base auto;
    }
  }
  .vertical{
    width: 100%;
    height: calc(100vh - 100*@vm_base);
    position: relative;
    .vertical_item{
      width: 100%;
      height: calc(100vh - 100*@vm_base);
      .level{
        width: 100%;
        height: calc(100vh - 100*@vm_base);
        overflow: hidden;
        .level_item{
          width: 100%;
          height: calc(100vh - 100*@vm_base);
          background-repeat: no-repeat;
          overflow: hidden;
          background-position: center center;
          // background-size: auto 100%;//原版
          background-size: cover;//新版
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          .bglevel_item{
            width: 100%;
            height: calc(100vh - 100*@vm_base);
            background-repeat: no-repeat;background-size: 100% calc(100vh - 100*@vm_base);//新版
          }
          .level_item_mask{
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.1);
            position: absolute;
            top: 0;
            left: 0;
          }
          .level_item_leftmask{
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            width: 120*@vm_base;
            height: 100%;
            background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
          }
          .level_item_num{
            position: absolute;
            top: 0;
            right: 0;
            z-index: 2;
            padding: 20*@vm_base 30*@vm_base 0 0;
            font-size: 32*@vm_base;
            font-weight: 500;
            color: #F3F3F3;
            label{
              font-size: 26*@vm_base;
              font-weight: 400;
            }
          }
          .level_item_carousel{
            position: absolute;
            top: 0;
            right: 0;
            z-index: 2;
            width: 41*@vm_base;
            margin-top: 77*@vm_base;
            margin-right: 30*@vm_base;
          }
          .reserves_fullpage_first_point{
            position: absolute;
            left: 0;
            // top: 0;
            margin-top: -200*@vm_base;
            z-index: 2;
            min-width: 460*@vm_base;
            min-height: 334*@vm_base;
            background-image: url(../../assets/images/base/stadiumAddressbg.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            display: flex;
            align-items: center;
            .reserves_fullpage_first_point_name{
              width: 100%;
              height: 84*@vm_base;
              line-height: 84*@vm_base;
              padding-left: 32*@vm_base;
              padding-right: 60*@vm_base;
              // margin-top: 52*@vm_base;
              font-size:56*@vm_base;
              font-weight:500;
              white-space: nowrap;
              color:rgba(255,255,255,1);
            }
            .reserves_fullpage_first_point_enname{
              width: 100%;
              height: 72*@vm_base;
              line-height: 72*@vm_base;
              padding-left: 32*@vm_base;
              padding-right: 60*@vm_base;
              font-size:44*@vm_base;
              font-weight:300;
              white-space: nowrap;
              color:rgba(199,198,204,1);
            }
            .reserves_fullpage_first_point_distance{
              width: 100%;
              height: 60*@vm_base;
              line-height: 60*@vm_base;
              padding-left: 32*@vm_base;
              padding-right: 60*@vm_base;
              font-size:44*@vm_base;
              font-size:24*@vm_base;
              white-space: nowrap;
              font-weight:500;
              color:rgba(255,255,255,0.7);
              .reserves_fullpage_first_point_distance_icon{
                width: 18*@vm_base;
                height: 60*@vm_base;
                float: left;
                background-image: url(../../assets/images/base/line_posi.png);
                background-size: 18*@vm_base 24*@vm_base;
                background-position: center center;
                background-repeat: no-repeat;
                margin-right: 10*@vm_base;
                // margin-left: 32*@vm_base;
              }
            }
          }
        }
      }
      .vertical_item_bock{
        position: relative;
        width: 100%;
        height: calc(100vh - 100*@vm_base);
        .level_item_tag{
          position: absolute;
          top: 0;
          left: 0;
          z-index: 3;
          width: calc(100% - 120*@vm_base);
          padding: 24*@vm_base 0 0 24*@vm_base;
          label{
            display: inline-block;
            padding: 8*@vm_base 24*@vm_base;
            color: #FFFFFF;
            float: left;
            font-size: 24*@vm_base;
            margin-right: 12*@vm_base;
            font-weight: 400;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 100*@vm_base 100*@vm_base 0px 100*@vm_base;
            margin-bottom: 12*@vm_base;
            border: 1*@vm_base solid #078B99;
          }
        }
      }
    }
    // .vertical_function{
    //   position: absolute;
    //   bottom: 0;
    //   right: 0;
    //   z-index: 3;
    //   width: 120*@vm_base;
    //   margin-bottom: 104*@vm_base;
    //   .vertical_function_item{
    //     width: 100%;
    //     position: relative;
    //     margin-bottom: 60*@vm_base;
    //     img{
    //       width: 60*@vm_base;
    //       margin: 0 auto;
    //     }
    //     .vertical_function_item_blackvip{
    //       width: 70%;
    //     }
    //     div{
    //       width: 100%;
    //       text-align: center;
    //       margin-top: 2*@vm_base;
    //       font-size: 28*@vm_base;
    //       font-weight: 400;
    //       color: #FFFFFF;
    //     }
    //     button{
    //       position: absolute;
    //       top: 0;
    //       left: 0;
    //       width: 100%;
    //       height: 120*@vm_base;background: none;
    //     }
    //   }
    // }
    .vertical_uoArrow{
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 3;
      width: 100%;
      height: 100*@vm_base;
      img{
        height: 100*@vm_base;
        margin: 0 auto;
      }
    }
    .order_panel{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 4;
      width: 100%;
      height: 0;
      max-height: calc(100vh - 120*@vm_base);
      overflow: hidden;
      overflow-y: auto;
      background: #FFFFFF;
      transition:all .5s ease-in;
      border-radius: 50*@vm_base 0px 0px 0px;
      .order_block{
        width: 100%;
        padding: 36*@vm_base 32*@vm_base 60*@vm_base 32*@vm_base;
        position: relative;
        .order_block_close{
          position: absolute;
          top: 0;
          right: 0;
          width: 90*@vm_base;
          height: 90*@vm_base;
          background-image: url(../../assets/images/base/icon_close.png);
          background-size: 50*@vm_base;
          background-position: center;
          background-repeat: no-repeat;
        }
        .order_block_title{
          width: 100%;
          padding: 0 89*@vm_base;
          .order_block_title_lab{
            float: left;
            div{
              width: 100*@vm_base;
              padding: 24*@vm_base 0;
              text-align: center;
              white-space: nowrap;
              margin: 0 auto;
              border-bottom:none;
              position: relative;
              .order_block_title_lab_item_lable{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 60%;
                margin-left: 20%;
              }
            }
          }
        }
        .order_block_dateOrder{
          width: 100%;
          padding: 81*@vm_base 0 0 0;
          overflow: hidden;
          overflow-x: auto;
          &::-webkit-scrollbar{width:0px}
          .order_son{
            width: calc(170*@vm_base * 8 + 18px);
            height: 150*@vm_base;
            margin-bottom: 64*@vm_base;
            .order_son_item{
              width: 150*@vm_base;
              height: 150*@vm_base;
              border-radius: 12*@vm_base;
              border: 1px solid #CCCCCC;
              float: left;
              margin-right: 20*@vm_base;
              text-align: center;
              font-weight: bold;
              padding-top: 36*@vm_base;
              .order_son_item_title{
                width: 80%;
                margin-left: 10%;
                font-size: 32*@vm_base;
                color: #444054;
                background: #FFFFFF;
              }
              .order_son_item_titleempty{
                color: #C7C6CC;
                background: #FFFFFF;
              }
              .order_son_item_titleSelect{
                color: #FFFFFF;
                background: #444054;
              }
              .order_son_item_item{
                font-weight: 400;
                font-size: 28*@vm_base;
                color: #8F8C98;
                font-weight: lighter;
              }
              .order_son_item_itemempty{
                color: #C7C6CC;
              }
              .order_son_item_itemnoempty{
                color: #444054;
              }
              .order_son_item_itemnoemptyselecty{
                color: #FFFFFF;
              }
            }
            .order_son_item_select{
              background: #444054;
            }
          }
          .order_fit_son_liu{
            width: calc(170*@vm_base * 6 + 14*@vm_base);
          }
          .order_fit_son_qi{
            width: calc(170*@vm_base * 7 + 14*@vm_base);
          }
          .order_fit_son_ba{
            width: calc(170*@vm_base * 8 + 14*@vm_base);
          }
          .order_fit_son_jiu{
            width: calc(170*@vm_base * 9 + 14*@vm_base);
          }
          .order_fit_son_tips{
            width: 100%;
            text-align: center;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #7C7987;
            line-height: 1;
            padding: 8*@vm_base 0;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
              width: 28*@vm_base;
              height: 28*@vm_base;
              margin-right: 12*@vm_base;
            }
          }
        }
        .order_son_submit{
          width: 100%;
          text-align: center;
          background: #444054;
          border-radius: 12*@vm_base;
          font-size: 32*@vm_base;
          font-weight: 500;
          color: #FFFFFF;
          padding: 23*@vm_base 0;
        }
        .order_son_submitNo{
          width: 100%;
          text-align: center;
          background: #F3F3F3;
          border-radius: 12*@vm_base;
          font-size: 32*@vm_base;
          font-weight: 500;
          color: #B4B3BB;
          padding: 23*@vm_base 0;
        }
        .order_yoga_date{
          width: 100%;
          padding: 81*@vm_base 0 0 0;
          overflow: hidden;
          overflow-x: auto;
          // border: 1px solid red;
          &::-webkit-scrollbar{width:0px;height: 0;}
          .order_yoga_son{
            width: calc(170*@vm_base * 7 + 18px);
            height: 150*@vm_base;
            margin-bottom: 60*@vm_base;
            .order_yoga_date_item{
              width: 150*@vm_base;
              height: 150*@vm_base;
              border: 1px solid #CCCCCC;
              float: left;
              margin-right: 20*@vm_base;
              text-align: center;
              font-weight: bold;
              color: #444054;
              padding-top: 36*@vm_base;
              border-radius: 12*@vm_base;
              .order_yoga_date_item_date{
                width: 80%;
                margin-left: 10%;
                font-size: 32*@vm_base;
                color: #444054;
                background: #FFFFFF;
              }
              .order_yoga_date_item_dateselect{
                color: #FFFFFF;
                background: #444054;
              }
              .order_yoga_date_item_dateempty{
                background: #FFFFFF;
                color: #C7C6CC;
              }
              .order_yoga_date_item_item{
                font-weight: lighter;
                font-size: 28*@vm_base;
                color: #444054;
              }
              .order_yoga_date_item_itemseselct{
                color: #FFFFFF;
              }
              .order_yoga_date_item_itemempty{
                color: #C7C6CC;
              }
              .order_yoga_date_item_itememptys{
                color: #444054;
              }
            }
            .order_yoga_date_item_select{
              background: #444054;
            }
          }
          .order_yoga_sonba{
            width: calc(170*@vm_base * 8 + 14*@vm_base);
          }
          .order_yoga_sonjiu{
            width: calc(170*@vm_base * 9 + 14*@vm_base);
          }
          .order_yoga_sonliu{
            width: calc(170*@vm_base * 6 + 14*@vm_base);
          }
        }

        .order_yoga_course_title{
          width: 100%;
          font-size: 32*@vm_base;
          font-weight: bold;
          color: #444054;
          margin-bottom: 24*@vm_base;
        }
        .order_yoga_course_empty{
          width: 100%;
        }
        .order_yoga_course_block{
          width: 100%;
          background: #FFFFFF;
          border-radius: 12*@vm_base;
          border: 2*@vm_base solid #EBEBEB;
          padding: 32*@vm_base;
          margin-bottom: 24*@vm_base;
          position: relative;
          // display: fl;
          .order_yoga_course_block_title{
            width: 100%;
            height: 32*@vm_base;
            font-size: 32*@vm_base;
            font-weight: bold;
            color: #444054;
            line-height: 32*@vm_base;
            label{
              display: inline-block;
              height: 32*@vm_base;
              line-height: 32*@vm_base;
              font-size: 24*@vm_base;
              font-weight: 400;
              color: #8F8C98;
            }
          }
          .order_yoga_course_block_des{
            width: 100%;
            margin-top:24*@vm_base;
            height: 24*@vm_base;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #8F8C98;
            line-height: 24*@vm_base;
          }
          .order_yoga_course_block_last{
            width: 100%;
            font-size: 28*@vm_base;
            font-weight: 400;
            color: #444054;
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            text-align: right;
            padding: 50*@vm_base 32*@vm_base 0 0;
            // border: 1px solid red;
            .order_ycbl_num{
              color: #F7B500;
            }
            .order_ycbl_over{
              // border: 1px solid red
              margin-top: 5*@vm_base;
              color: #c7c6cc;
              font-size: 24*@vm_base;
              line-height: 1.2;
              // img{
              //   display: inline-block;
              //   height: 26*@vm_base;
              //   vertical-align:bottom
              //   // margin-top: 10*@vm_base;
              // }
            }
          }
        }
        .order_yoga_course_block_select{
          border: 2*@vm_base solid #f7b500;
        }
        .order_yoga_submit{
          width: 100%;
          background: #444054;
          border-radius: 12*@vm_base;
          text-align: center;
          font-size: 32*@vm_base;
          font-weight: 500;
          color: #FFFFFF;
          padding: 23*@vm_base 0;
          margin-top: 85*@vm_base;
        }
        .order_yoga_submitno{
          width: 100%;
          background: #F3F3F3;
          border-radius: 12*@vm_base;
          text-align: center;
          font-size: 32*@vm_base;
          font-weight: 500;
          color: #B4B3BB;
          padding: 23*@vm_base 0;
          margin-top: 85*@vm_base;
        }
      }
    }
    .order_panel.order_active{
      height: auto;
    }
    .desc{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 4;
      width: 100%;
      height: 0;
      // max-height: calc(100vh - 120*@vm_base);
      max-height: 68vh;
      background: #fefefe;
      border-radius: 50*@vm_base 50*@vm_base 0px 0px;
      overflow: hidden;
      .desc_cont{
        width: 100%;
        // padding: 10*@vm_base 32*@vm_base;
        // position: relative;
        max-height: calc(68vh - 120*@vm_base);
        overflow: hidden;
        // overflow-y: auto;
        .desc_cont_address{
          width: 100%;
          padding: 40*@vm_base 0 40*@vm_base 36*@vm_base;
          font-size: 32*@vm_base;
          font-weight: 500;
          color: #333333;
          background-image: url(../../assets/images/base/order_details_location.png);
          background-size: 24*@vm_base auto;
          background-position: left 45*@vm_base;
          background-repeat: no-repeat;
        }
        .desc_cont_serves{
          width: 100%;
          margin-bottom: 40*@vm_base;
          .desc_title{
            width: 100%;
            font-size: 32*@vm_base;
            font-weight: 500;
            color: #333333;
          }
          .desc_Service_cont{
            width: calc(100% + 12*@vm_base);
            padding: 8*@vm_base 0 0 0;
            .desc_Service_cont_item{
              width: calc(25% - 12*@vm_base);
              background: #F8F8F8;
              border-radius: 6*@vm_base;
              margin-right: 12*@vm_base;
              margin-top: 12*@vm_base;
              float: left;
              height: 72*@vm_base;
              text-align: center;
              font-size: 24*@vm_base;
              font-weight: 400;
              color: #333333;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                width: 30*@vm_base;
              }
            }
          }
          .desc_Service_detailDesc{
            width: 100%;
            background: #F8F8F8;
            border-radius: 6*@vm_base;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #333333;
            padding: 30*@vm_base;
            margin: 20*@vm_base 0 0 0;
          }
        }
        .desc_cont_businesstime{
          width: 100%;
          padding-bottom: 40*@vm_base;
          .desc_cont_businesstime_title{
            width: 100%;
            font-size: 32*@vm_base;
            font-weight: 500;
            color: #333333;
          }
          .desc_cont_businesstime_cont{
            width: 100%;
            background: #F8F8F8;
            border-radius: 6*@vm_base;
            font-size: 24*@vm_base;
            font-weight: 400;
            color: #333333;
            padding: 30*@vm_base;
            margin: 20*@vm_base 0 0 0;
            white-space: pre-wrap;
          }
        }
        .desc_cont_businesstime_bott{
          margin-bottom: 80*@vm_base;
        }
        .desc_cont_close{
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          background: #FFFFFF;
          padding: 20*@vm_base 32*@vm_base;

          box-shadow: 0px -4*@vm_base 40*@vm_base 0px rgba(0, 0, 0, 0.1);

          .desc_cont_close_close{
            float: left;
            width: 150*@vm_base;
            height: 80*@vm_base;
            border: 1*@vm_base solid #DDDDDD;
            line-height: 80*@vm_base;
            text-align: center;
            border-radius: 12*@vm_base;
            font-size: 28*@vm_base;
            color: #444054;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              height: 34*@vm_base;
              margin-right: 10*@vm_base;
            }
          }
          .desc_cont_close_submi{
            float: right;
            width: calc(100% - 180*@vm_base);
            border: 1*@vm_base solid #444054;
            height: 80*@vm_base;
            background: #444054;
            border-radius: 12*@vm_base;
            line-height: 80*@vm_base;
            text-align: center;
            color: #FFFFFF;
            font-size: 32*@vm_base;
          }
        }
      }
    }
    .desc_avtive{
      height: 68vh;
    }
    .order_son_item_posi{
      position: relative;
      .order_son_item_posi_icon{
        position: absolute;
        top: 0;
        right: 0;
        width: 50%;
      }
    }
  }
  .hotailVider{
    position: absolute;
    width: 100%;
    height: calc(100vh - 100*@vm_base);
    bottom: 0;
    left: 0;
    z-index: 5;
    video{
      width: 100%;
      height: calc(100vh - 100*@vm_base);
    }
  }
  .hotailViderMask{
    position: absolute;
    width: 100%;
    height: calc(100vh - 100*@vm_base);
    bottom: 0;
    left: 0;
    z-index: 6;
    background: rgba(0,0,0,0.0);
    .hotailViderMask_pause{
      width: 60*@vm_base;
      margin: calc(50vh - 150*@vm_base) auto 0 auto;
    }
  }
  .hotailViderMask_close{
    position: absolute;
    width: 120*@vm_base;
    height: 120*@vm_base;
    top: 0;
    right: 0;
    z-index: 7;
    // margin-right: 30*@vm_base;
    margin-top: 100*@vm_base;
    img{
      width: 30*@vm_base;
      float: right;
      margin-top: 40*@vm_base;
      margin-right: 40*@vm_base;
    }
  }
  // ---v2.2---
  .fl_yc{
    width: calc(100% + 12*@vm_base);
    position: relative;
    height: 143*@vm_base;
    // height: 110*@vm_base;
    .fl_yogaCourse{
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      padding-bottom: 44*@vm_base;
      white-space: nowrap;
      overflow-x: auto;
      -webkit-overflow-scrolling:touch;
      &::-webkit-scrollbar{width:0;height: 0;}
      .fl_yogaCourse_item{
        display: inline-block;
        // float: left;
        padding: 17*@vm_base 48*@vm_base;
        border-radius: 30*@vm_base;
        border: 1*@vm_base solid #CCCCCC;
        font-size: 26*@vm_base;
        font-weight: 400;
        color: #444054;
        margin-right: 20*@vm_base;
        position: relative;
        background-image: none;
        background-position: 20*@vm_base center;
        background-repeat: no-repeat;
        background-size: 20*@vm_base 16*@vm_base;
        text-align: center;
        .fl_yogaCourse_item_arrow{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 30*@vm_base;
          height: 20*@vm_base;
          margin-bottom: -44*@vm_base;
          margin-left: 96*@vm_base;
        }
      }
      .fl_yogaCourse_itemS{
        background-image: url(../../assets/images/FLVersion/nav_locationselect_fix.png);
        border: 1*@vm_base solid #444054;
      }
    }
  }
  .fl_ycDetail{
    border: 1*@vm_base solid #CCCCCC;
    padding: 32*@vm_base;
    border-radius: 12*@vm_base;
    .fl_ycDetail_title{
      width: 100%;
      font-size: 32*@vm_base;
      font-weight: 600;
      color: #444054;

      .fl_ycDetail_title_sur{
        display: inline-block;
        word-break: break-all;
        width: 72%;
      }
      .fl_ycDetail_title_surplus{
        width: 28%;
        text-align: right;
        display: inline-block;
        float: right;
        font-size: 24*@vm_base;
        // padding: 4*@vm_base 0;
        font-weight: 400;
        color: #8F8C98;
        letter-spacing: 1px;
        label{
          color: #444054;
          font-size: 32*@vm_base;
          font-weight: 600;
        }
      }
    }
    .fl_ycDetail_stitle{
      padding: 13*@vm_base 0 15*@vm_base 0;
      width: 100%;
      font-size: 24*@vm_base;
      font-weight: 400;
      color: #8F8C98;
      .fl_ycDetail_stitle_surplus{
        float: right;
      }
    }
    .fl_ycDetail_desc{
      width: 100%;
      border-top: 1*@vm_base solid #E7E7E7;
      padding-top: 26*@vm_base;
      font-size: 24*@vm_base;
      font-weight: 400;
      color: #8F8C98;
      line-height: 33*@vm_base;
    }
  }
  // 健身模块预约提示
  .fl_order_fit_son_tips{
    width: 100%;
    text-align: center;
    font-size: 24*@vm_base;
    font-weight: 400;
    color: #7C7987;
    // line-height: 1;
    padding: 8*@vm_base 0 40*@vm_base 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -20*@vm_base;
    img{
      width: 28*@vm_base;
      height: 28*@vm_base;
      margin-right: 12*@vm_base;
    }
  }
  // 酒店介绍
  .fl_des_tab{
    width: 100%;
    height: calc(68vh - 120*@vm_base);
    padding: 32*@vm_base 32*@vm_base 0 32*@vm_base;
    .fl_des_tab_head{
      width: 100%;
      .fl_des_tab_head_item{
        width: calc(33.33% - 6.66*@vm_base);
        float: left;
        text-align: center;
        border-bottom: 2*@vm_base solid #DDDDDD;
        padding: 28*@vm_base 0;
        font-size: 28*@vm_base;
        font-weight: 400;
        color: #999999;
        line-height: 1;
        letter-spacing: 1px;
      }
      .fl_des_tab_head_item2{
        margin-left: 9.99*@vm_base;
      }
      .fl_des_tab_head_itemS{
        color: #000000;
        border-bottom: 2*@vm_base solid #000000;
      }
    }
    .fl_des_tab_body{
      // border: 1px solid red;
      width: 100%;
      height: calc(68vh - 240*@vm_base);
      padding: 0 0 20*@vm_base 0;
      overflow: hidden;
      overflow-y: auto;
      .fl_dtb_item{
        width: 100%;
        .fl_dtb_item_address{
          width: 100%;
          padding: 41*@vm_base 0 0 0;
          .fl_dtb_item_address_ad{
            width: calc(100% - 67*@vm_base);
            float:left;
            height: 72*@vm_base;
            margin-bottom: 19*@vm_base;
            font-size: 26*@vm_base;
            font-weight: 400;
            color: #333333;
            line-height: 1.38;
            padding-left: 32*@vm_base;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;

            background-image: url(../../assets/images/base/posi.png);
            background-position: left 5*@vm_base;
            background-size: 20*@vm_base 26*@vm_base;
            background-repeat: no-repeat;
          }
          .fl_dtb_item_address_ic{
            width: 66*@vm_base;
            height: 36*@vm_base;
            float:left;
            border-left: 1*@vm_base solid #DDDDDD;

            background-image: url(../../assets/images/base/navigation.png);
            background-size: 36*@vm_base 36*@vm_base;
            background-repeat: no-repeat;
            background-position: right center;
          }
        }
        .fl_dtb_item_business{
          width: 100%;
          padding: 0;
          // border: 1px solid red;
          // height: 180*@vm_base;
          position: relative;
          padding-bottom: 60*@vm_base;
          .fl_dtb_item_business_title{
            width: 100%;
            font-size: 28*@vm_base;
            font-weight: bold;
            color: #000000;
            line-height: 1;
          }
          .fl_dtb_item_business_conte{
            width: 100%;
            font-size: 26*@vm_base;
            font-weight: 400;
            color: #333333;
            margin-top: 28*@vm_base;

          }
          .fl_dtb_item_servers_conte{
            width: 100%;
            margin-top: 28*@vm_base;
            overflow: hidden;
            overflow-x: auto;
            // border: 1px solid red;
            height: 120*@vm_base;
            &::-webkit-scrollbar{width:0px;height: 0;}
            .fl_dtbisc_block{
              .fl_dtbiscb_item{
                width: 126*@vm_base;
                border: 1px solid red;
                margin-right: 14*@vm_base;
                float: left;
                padding: 16*@vm_base 0;
                text-align: center;
                font-size: 24*@vm_base;
                font-weight: 400;
                color: #333333;
                line-height: 1;
                background: #FFFFFF;
                border-radius: 6*@vm_base;
                border: 1*@vm_base solid #DDDDDD;
                position: relative;
                .fl_dtbiscb_item_img{
                  width: 30*@vm_base;
                  margin: 0 auto;
                  margin-bottom: 8*@vm_base;
                }
                .fl_dtbiscb_item_popup{
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 30*@vm_base;
                  height: 20*@vm_base;
                  margin-left: calc(50% - 15*@vm_base);
                  margin-bottom: -26*@vm_base;
                }
              }
              .fl_dtbiscb_itemS{
                background: #EFEAE1;
              }
            }
          }

        }
        .fl_dtb_item_businessMS{
          width: 100%;
          padding: 0;
          // border: 1px solid red;
          height: 180*@vm_base;
          position: relative;
          .fl_dtb_item_businessMS_mm{
            position: absolute;
            width: 100%;
            // border: 1px solid red;
            top: 0;
            left: 0;
            height: 200*@vm_base;
            z-index: 111;
          }
          .fl_dtb_item_business_title{
            width: 100%;
            font-size: 28*@vm_base;
            font-weight: bold;
            color: #000000;
            line-height: 1;
          }
          .fl_dtb_item_business_conte{
            width: 100%;
            font-size: 26*@vm_base;
            font-weight: 400;
            color: #333333;
            margin-top: 28*@vm_base;

          }
          .fl_dtb_item_servers_conte{
            width: 100%;
            margin-top: 28*@vm_base;
            overflow: hidden;
            overflow-x: auto;
            // border: 1px solid red;
            height: 180*@vm_base;
            &::-webkit-scrollbar{width:0px;height: 0;}
            .fl_dtbisc_block{
              .fl_dtbiscb_item{
                width: 156*@vm_base;
                margin-right: 14*@vm_base;
                float: left;
                padding: 16*@vm_base 0;
                text-align: center;
                font-size: 24*@vm_base;
                font-weight: 400;
                color: #333333;
                line-height: 1;
                background: #FFFFFF;
                border-radius: 6*@vm_base;
                border: 1*@vm_base solid #DDDDDD;
                position: relative;
                white-space: nowrap;
                .fl_dtbiscb_item_img{
                  width: 30*@vm_base;
                  margin: 0 auto;
                  margin-bottom: 8*@vm_base;
                }
                .fl_dtbiscb_item_popup{
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 30*@vm_base;
                  height: 20*@vm_base;
                  margin-left: calc(50% - 15*@vm_base);
                  margin-bottom: -35*@vm_base;
                  // border: 1px solid red;
                }
              }
              .fl_dtbiscb_itemS{
                background: #EFEAE1;
              }
            }
          }
        }
      }
      .fl_dtb_item_servers_conteTip{
        width: 100%;
        border-radius: 12*@vm_base;
        border: 1*@vm_base solid #DDDDDD;
        padding: 30*@vm_base;
        font-size: 26*@vm_base;
        font-weight: 400;
        color: #333333;
        line-height: 1.4;
      }
      .fl_dtb_item_book_tip{
        width: 100%;
        font-size: 26*@vm_base;
        font-weight: 500;
        color: #333333;
        line-height: 1.8;
        word-break: break-all;
        white-space: pre-wrap;
        padding: 40*@vm_base 32*@vm_base;
      }
      .fl_dtb_item_introduce{
        width: 100%;
        font-size: 26*@vm_base;
        font-weight: 500;
        color: #333333;
        line-height: 1.8;
        word-break: break-all;
        white-space: pre-wrap;
        padding: 40*@vm_base 32*@vm_base;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/reserve/resdetail.vue